<template>
  <div class="hotel_container">
    <div class="hotel_container_panel">
      <Loading :loading="detailLoading" />
      <!-- begin confirmed panel-->
      <div
        class="order_confirm_panel spacing"
        v-if="$objBaseInfo.channelId == 'MOBILE'"
      >
        <div :class="'icon-title' + orderInfo.bookingStatus">
          <!-- BOOKED:预订成功  CANCELLED：已取消 CHECKOUT：已离店 -->
          <span
            class="span_icon"
            v-if="
              orderInfo.bookingStatus == 'BOOKED' ||
              orderInfo.bookingStatus == 'CANCELLED' ||
              orderInfo.bookingStatus == 'CHECKOUT'
            "
          >
            <svg-icon
              icon-class="circle-check"
              class-name="icon-circlecheck"
            ></svg-icon>
          </span>
          <!-- PENDING_CONFIRMATION：等待确认 PENDING_BOOKING:待预订 -->
          <span
            class="span_icon"
            v-if="
              orderInfo.bookingStatus == 'CWT_PENDING_CONFIRMATION' ||
              orderInfo.bookingStatus == 'CWT_PENDING_CANCELLATION' ||
              orderInfo.bookingStatus == 'PENDING_CONFIRMATION' ||
              orderInfo.bookingStatus == 'PENDING_BOOKING'
            "
          >
            <svg-icon
              icon-class="ic_help_outline"
              class-name="icon-circlecheck"
            ></svg-icon>
          </span>
          <!-- NOSHOW：未到店 -->
          <span class="span_icon" v-if="orderInfo.bookingStatus == 'NOSHOW'">
            <svg-icon
              icon-class="exclamation"
              class-name="icon-circlecheck"
            ></svg-icon>
          </span>
          <span class="confirm_text">{{
            orderInfo.bookingStatus
              ? $t("COMMONPARAM.ORDERSTATE." + convertOrderStatus())
              : ""
          }}</span>
          <span v-show="orderInfo.bookingStatus == 'PENDING_BOOKING' && orderInfo.paymentType == 2" class="colorRed" style="padding-left:10px;">{{ $t("CONFIRMATION.PAYMENTSTATUSPRETIPS") }}</span>
          <!-- <div style="float:right" v-if="isShowBtn">
            <el-button type="text" icon="el-icon-arrow-left" @click="BackOrderList()">{{ $t("CONFIRMATION.BACK") }}</el-button>
          </div> -->
          <el-link type="primary" :underline="false" style=" border-bottom: 1px solid #409eff;float: right;" 
          v-if="orderInfo.bookingStatus == 'BOOKED' ||orderInfo.bookingStatus == 'CHECKOUT'" @click="showApprovedDialog('H5')">
            {{ $t("SEARCH.APPROVED") }}
          </el-link>
        </div>
        <div class="order_num">
          <div class="order_title">{{ $t("CONFIRMATION.ORDERNUM") }}</div>
          <div class="info">
            {{ orderInfo.bookingId }}
          </div>
        </div>
        <div class="order_num" style="margin-top:10px;">
          <div v-if="perPayDetails.isShowBilling">
            <el-button type="primary" @click="ShowRefundDialog" class="s_btn" style="display: inline-flex; align-items: center; justify-content: center; line-height: normal; padding: 0 1rem; height: 3rem;">{{ getInvoiceStatus()}}</el-button>
          </div>
          <div v-if="perPayDetails.refundStatus != 0">
            <span style="padding:0rem 1rem;font-size:13px"> {{ $t("REFUNDREQUESTBUTTONMSG.REFUNDREQUEST" + perPayDetails.refundStatus)}}</span>
          </div>
        </div>
        <div v-if="perPayDetails.isShowFinishOrderBtn" style="margin-top:10px;color:#fc6640">
          <span>{{ $t("CONFIRMATION.PREPAYREMARK") }}</span>
        </div>
        <div style="text-align: end;" 
          v-if="!orderInfo.isManualOrder &&(
                orderInfo.bookingStatus == 'BOOKED' ||
                orderInfo.bookingStatus == 'CHECKOUT'||
                orderInfo.bookingStatus == 'CANCELLED'||
                orderInfo.bookingStatus == 'NOSHOW'||
                orderInfo.bookingStatus == 'CWT_PENDING_CANCELLATION'||
                orderInfo.bookingStatus == 'CWT_PENDING_APPROVAL')">
          <el-button class="s_btn" style="height: 2.5rem; padding: 0rem 1rem"  @click="copyOrderClick">{{ $t("BOOKING.CopyButton") }}</el-button>
        </div>
      </div>
      <!-- end confirmed panel-->
      <div class="confirmation_panel">
        <div class="info_detal_l">
          <!-- begin confirmed panel-->
          <div class="order_confirm_panel spacing" v-if="$objBaseInfo.channelId == 'WEB'">
            <div :class="'icon-title' + orderInfo.bookingStatus">
              <!-- BOOKED:预订成功  CANCELLED：已取消 CHECKOUT：已离店 -->
              <span class="span_icon" v-if="
                  orderInfo.bookingStatus == 'BOOKED' ||
                  orderInfo.bookingStatus == 'CANCELLED' ||
                  orderInfo.bookingStatus == 'CHECKOUT'">
                <svg-icon icon-class="circle-check" class-name="icon-circlecheck"></svg-icon>
              </span>
              <!-- PENDING_CONFIRMATION：等待确认 PENDING_BOOKING:待预订 -->
              <span class="span_icon" v-if="
                  orderInfo.bookingStatus == 'CWT_PENDING_CONFIRMATION' ||
                  orderInfo.bookingStatus == 'CWT_PENDING_CANCELLATION' ||
                  orderInfo.bookingStatus == 'PENDING_CONFIRMATION' ||
                  orderInfo.bookingStatus == 'PENDING_BOOKING'">
                <svg-icon icon-class="ic_help_outline" class-name="icon-circlecheck"></svg-icon>
              </span>
              <!-- NOSHOW：未到店 -->
              <span class="span_icon" v-if="
                  orderInfo.bookingStatus == 'NOSHOW' ||
                  orderInfo.bookingStatus == 'BOOKING_FAILED'">
                <svg-icon icon-class="exclamation" class-name="icon-circlecheck"></svg-icon>
              </span>
              <span class="confirm_text">{{ orderInfo.bookingStatus? $t("COMMONPARAM.ORDERSTATE." + convertOrderStatus()): ""}}</span>
              <span v-show="orderInfo.bookingStatus == 'PENDING_BOOKING' && orderInfo.paymentType == 2" class="colorRed" style="padding-left:10px;">{{ $t("CONFIRMATION.PAYMENTSTATUSPRETIPS") }}</span>
              <div style="float: right" v-if="isShowBtn">
                <el-button
                  type="text"
                  icon="el-icon-arrow-left"
                  @click="BackOrderList()"
                  >{{ $t("CONFIRMATION.BACK") }}</el-button
                >
              </div>
            </div>
            <div class="order_num">
              <div class="order_title">{{ $t("CONFIRMATION.ORDERNUM") }}</div>
              <div class="info">{{ orderInfo.bookingId }}</div>
              <div style="padding-left: 20px;" v-if="perPayDetails.isShowBilling">
                <el-button type="primary" @click="ShowRefundDialog" class="s_btn" style="height:2rem;padding:0rem 1rem;">{{getInvoiceStatus()}}</el-button>
              </div>
              <div style="padding-left: 20px;" v-if="perPayDetails.isShowRefundBtn">
                <el-button v-if="$objBaseInfo.sourceType == 'CRM'" class="footer-button-c" @click="refundRequest" style="height:2rem;padding:0rem 1rem;"> {{ $t("REFUNDREQUESTBUTTONMSG.REFUNDREQUEST0")}}</el-button>
              </div>
              <div style="padding-left: 20px;" v-if="perPayDetails.refundStatus != 0">
                <span style="height:2rem;padding:0rem 1rem;"> {{ $t("REFUNDREQUESTBUTTONMSG.REFUNDREQUEST" + perPayDetails.refundStatus)}}</span>
              </div>
              <!-- <div  style="margin-left :auto"  @click="showApprovedDialog"> -->
              <!-- class="price_link main_link_tab" -->
              <div style="margin-left:15px;">
                <el-link
                type="primary"
                :underline="false"
                style="border-bottom: 1px solid #409eff;margin-right: 4rem;"
                v-if="
                  this.$objBaseInfo.sourceType == 'CRM' && (
                  orderInfo.bookingStatus == 'BOOKED' ||
                  orderInfo.bookingStatus == 'CHECKOUT'||
                  orderInfo.bookingStatus == 'CANCELLED'||
                  orderInfo.bookingStatus == 'BOOKING_FAILED')
                "
                @click="showSMSDialog"
              >
                {{ $t("RESENTSMSINFO.RESENTSMS") }}
              </el-link>
              <el-link
                type="primary"
                :underline="false"
                style=" border-bottom: 1px solid #409eff;margin-right: 4rem;"
                v-if="
                  orderInfo.bookingStatus == 'BOOKED' ||
                  orderInfo.bookingStatus == 'CHECKOUT'
                "
                @click="showApprovedDialog('PC')"
              >
                {{ $t("SEARCH.APPROVED") }}
              </el-link>
              <el-link type="primary" :underline="false" style=" border-bottom: 1px solid #409eff" v-if="this.$objBaseInfo.sourceType == 'CRM' && orderInfo.source == 'CWTbur'" @click="bookingsDownLoadPDF()">
                {{ $t("RESENTSMSINFO.DOWNLOADPDF") }}
              </el-link>
              </div>
            </div>
            <div v-if="perPayDetails.isShowFinishOrderBtn" style="margin-top:10px;color:#fc6640">
              <span>{{ $t("CONFIRMATION.PREPAYREMARK") }}</span>
            </div>
            <div style="text-align: end;" 
             v-if="!orderInfo.isManualOrder &&(
                   orderInfo.bookingStatus == 'BOOKED' ||
                   orderInfo.bookingStatus == 'CHECKOUT'||
                   orderInfo.bookingStatus == 'CANCELLED'||
                   orderInfo.bookingStatus == 'NOSHOW'||
                   orderInfo.bookingStatus == 'CWT_PENDING_CANCELLATION'||
                   orderInfo.bookingStatus == 'CWT_PENDING_APPROVAL')">
              <el-button class="s_btn" style="height: 2.5rem; padding: 0rem 1rem"  @click="copyOrderClick">{{ $t("BOOKING.CopyButton") }}</el-button>
            </div>
          </div>
          <!-- end confirmed panel-->
          <!-- begin Need to know -->
          <div class="order_confirm_panel spacing">
            <div class="panel_underline_title">
              <span>{{ $t("CONFIRMATION.NEEDTOKNOW") }}</span>
            </div>
            <div class="order_need">
              <div
                v-if="
                  orderInfo.hoteDescriptiveInfo &&
                  orderInfo.hoteDescriptiveInfo.Country == '100000'
                "
                class="order_need_item"
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{
                    orderInfo.isForeignerAllowed
                      ? $t("DETAIL.FOREIGNGUESTS2")
                      : $t("DETAIL.FOREIGNGUESTS1")
                  }}
                </div>
              </div>
              <div
                class="order_need_item"
                v-if="orderInfo.cancellationRules.cancellationPolicy === 0"
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{ $t("CONFIRMATION.NEEDNO") }}
                </div>
              </div>
              <div
                class="order_need_item"
                v-if="orderInfo.cancellationRules.cancellationPolicy == 1"
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{ $t("CONFIRMATION.NEEDYES") }}
                </div>
              </div>
              <div
                class="order_need_item"
                v-if="orderInfo.cancellationRules.cancellationPolicy == 2"
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{
                    $t("CONFIRMATION.NEED2", {
                      date: convertCancellationDate(),
                    })
                  }}
                </div>
              </div>
              <div
                class="order_need_item"
                v-if="
                  orderInfo.guaranteeType == 1 &&
                  orderInfo.cancellationRules.cancellationPolicy == 2
                "
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{
                    $t("CONFIRMATION.NEED3ALL", {
                      date: convertCancellationDate(),
                    })
                  }}
                </div>
              </div>
              <div
                class="order_need_item"
                v-if="
                  orderInfo.guaranteeType == 2 &&
                  orderInfo.cancellationRules.cancellationPolicy == 2
                "
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{
                    $t("CONFIRMATION.NEED3", {
                      date: convertCancellationDate(),
                    })
                  }}
                </div>
              </div>
              <div
                class="order_need_item"
                v-if="
                  orderInfo.guaranteeType == 5 &&
                  orderInfo.cancellationRules.cancellationPolicy == 2
                "
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{
                    $t("CONFIRMATION.NEED5", {
                      date: convertCancellationDate(),
                    })
                  }}
                </div>
              </div>
              <div
                class="order_need_item"
                v-if="
                  orderInfo.paymentInfo.isVirtualCard
                "
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{
                    $t("CONFIRMATION.NEED6")
                  }}
                </div>
              </div>
              <!-- 延时预订显示 即时预订不显示 -->
              <div class="order_need_item" v-if="orderInfo.source == 'CWTbur'">
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{ $t("BOOKING.BURTIPS3", {
                    customPhone: getCustomPhone,
                  }) }}
                </div>
              </div>
              <!-- 现付 非担保 -->
              <div
                class="order_need_item"
                v-if="
                  orderInfo.paymentInfo.paymentType == '1' &&
                  orderInfo.guaranteeType == 3
                "
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{ $t("BOOKING.SPECIALALERT") }}
                </div>
              </div>
              <!-- 公付 -->
              <div
                class="order_need_item"
                v-if="orderInfo.paymentInfo.paymentType == '3'"
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{ $t("BOOKING.SPECIALALERT1") }}
                </div>
              </div>
              <!-- Sabre、elong、booking 现付，不可取消，担保资源，一律加话述提示 -->
              <div   
                class="order_need_item"
                v-if="(orderInfo.source.indexOf('sabre')>=0 || orderInfo.source.indexOf('booking')>=0) &&
                orderInfo.paymentInfo.paymentType == '1' && 
                orderInfo.cancellationRules.cancellationPolicy == '0'"
              >
                <svg-icon icon-class="exclamation"></svg-icon>
                <div class="order_need_text">
                  {{ $t("EGuarantee.SabreDetailTIPMSG") }}
                </div>
              </div>
            </div>
            <div
              class="colorRed"
              v-if="orderInfo.bookingStatus == 'PENDING_CONFIRMATION' && bookingType=='bur' && orderInfo.source != 'CWTbur'"
            >
              {{ $t("BOOKING.BURBOOKINGTITLE") }}
            </div>
            <div
              class="colorRed"
              v-if="orderInfo.source == 'elong' &&
                    orderInfo.paymentInfo.paymentType == 1 &&
                    orderInfo.reservationType == 0 &&
                    orderInfo.bookingStatus == 'PENDING_CONFIRMATION'">
              {{ $t("BOOKING.ELONGGUARANTEE") }}
            </div>
            <div class="order_need_item" v-if="intlTaxDisplay == '1'">
              <svg-icon icon-class="exclamation"></svg-icon>
              <div class="order_need_text">
                {{ $t("BOOKING.INTLTAXDISPLAY") }}
              </div>
            </div>
          </div>
          <!-- end Need to know -->
          <personnelInfo ref="personnelInfo"></personnelInfo>
          <ConfirmationSpecial ref="specialRef"></ConfirmationSpecial>
        </div>
        <ConfirmationRight></ConfirmationRight>
        
      </div>
    </div>
    
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      icon="exclamation"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <!-- begin HotelOrderEmail dialog -->
    <el-dialog :title="$t('HOTELORDEREMAIL.APPROVEDINFO')" class="price-dialog" width="98rem" v-model="hotelOrderEmail.showEmailFlag" :show-close="false">
      <Loading :loading="repeatEmailLoading" />
      <div class="add-guest-div">
        <Loading :loading="repeatEmailLoading" />
        <el-button size="default" class="add-guest-btn" @click="repeatEmail('PC')">
          {{ $t("HOTELORDEREMAIL.REPEAT") }}
        </el-button>
      </div>
      <el-divider class="title-divider"></el-divider>
      <div class="form">
        <el-row :gutter="10">
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("HOTELORDEREMAIL.SUBSCRIBEREMAIL") }}
              </div>
              <el-input
                size="default"
                v-model="hotelOrderEmail.hotelOrderEmailInfo.reciveEmail"
              ></el-input>
              <!-- <div class="lable_value_review">{{ orderInfo.bookingAgent[0].name }}</div> -->
            </div>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("HOTELORDEREMAIL.CHECKINEMAIL") }}
              </div>
              <el-input
                size="default"
                v-model="hotelOrderEmail.hotelOrderEmailInfo.checkinEmail"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("HOTELORDEREMAIL.CCEMAIL") }}
              </div>
              <el-input
                size="default"
                :placeholder="$t('CONFIRMATION.CCTITLE')"
                v-model="hotelOrderEmail.hotelOrderEmailInfo.ccEmail"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field"></div>
              <el-radio v-model="hotelOrderEmail.showEnTemplate" label="1">{{ $t("HOTELORDEREMAIL.CNNAME") }}</el-radio>
              <el-radio v-model="hotelOrderEmail.showEnTemplate" label="2" style="margin-left: 2rem">{{ $t("HOTELORDEREMAIL.ENNAME") }}</el-radio>
              <!-- <el-switch
                v-model="hotelOrderEmail.showEnTemplate"
                :active-color="hotelOrderEmail.showEnTemplateColor"
                :inactive-color="hotelOrderEmail.showCnTemplateColor"
                :active-text="hotelOrderEmail.EnName"
                :inactive-text="hotelOrderEmail.CnName"
              ></el-switch> -->
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col>
            <div class="grid-content" style="padding-top: 3rem">
              <div
                v-html="hotelOrderEmail.hotelOrderEmailInfo.emailContent"
              ></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- end HotelOrderEmail dialog -->

    <!-- begin RemarkInfo dialog -->
    <el-dialog
      :title="$t('REMARKINFO.REMARKLOG')"
      class="price-dialog"
      :visible.sync="remarkInfo.showRemarkFlag"
      :show-close="false"
    >
      <div class="add-guest-div">
        <el-button size="small" class="add-guest-btn" @click="addRemark()">
          {{ $t("REMARKINFO.ADDREMARK") }}
        </el-button>
      </div>
      <el-divider class="title-divider"></el-divider>
      <el-table :data="remarkInfo.clientData" class="" width="100%">
        <el-table-column
          prop="Date"
          align="center"
          :label="$t('REMARKINFO.DATE')"
          min-width="110"
        ></el-table-column>
        <el-table-column
          prop="Detail"
          align="center"
          :label="$t('REMARKINFO.DETAIL')"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="Operator"
          align="center"
          :label="$t('REMARKINFO.OPERATOR')"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <!-- end RemarkInfo dialog -->

    <!-- begin hotelOrderSMS dialog -->
    <el-dialog :title="$t('RESENTSMSINFO.SMSINFO')" class="price-dialog" width="98rem" v-model="hotelOrderSMS.showSMSFlag" :show-close="false">
      <Loading :loading="hotelOrderSMS.repeatSMSLoading" />
      <div class="add-guest-div">
        <Loading :loading="hotelOrderSMS.repeatSMSLoading" />
        <el-button size="default" class="add-guest-btn" @click="repeatSMS()">
          {{ $t("RESENTSMSINFO.SEND") }}
        </el-button>
      </div>
      <el-divider class="title-divider"></el-divider>
      <div class="form">
        <el-form :model="hotelOrderSMS" label-position="right" :rules="smsRules" ref="smsRules" :inline="true">
          <el-row :gutter="10">
            <el-col :xs="24" :lg="12">
              <el-form-item :label="$t('RESENTSMSINFO.BOOKINGAGENTMOBILE')" prop="bookingAgentMobile">
                <el-input size="default" v-model="hotelOrderSMS.bookingAgentMobile" @input="clearNoNumBookingAgentMobile()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item :label="$t('RESENTSMSINFO.GUESTMOBILE')" prop="guestMobile">
                <el-input size="default" v-model="hotelOrderSMS.guestMobile" @input="clearNoNumGuestMobile()"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field"></div>
              <el-radio v-model="hotelOrderSMS.showEnTemplate" label="1" @change="changeSelectLanguage">{{ $t("HOTELORDEREMAIL.CNNAME") }}</el-radio>
              <el-radio v-model="hotelOrderSMS.showEnTemplate" label="2" style="margin-left: 2rem" @change="changeSelectLanguage">{{ $t("HOTELORDEREMAIL.ENNAME") }}</el-radio>
            </div>
          </el-col>
        </el-row>
        <el-divider class="middle-divider" style="margin-top: 2rem!important;"></el-divider>
        <el-row :gutter="10">
          <el-col>
            <div class="grid-content">
              <div v-for="(item, index) in hotelOrderSMS.hotelOrderSMSInfo" :key="'sms' + index">
                <div class="smsModel_div" v-if="hotelOrderSMS.smsLanguage == item.language">
                  <div style="width: 20rem;">
                    <el-radio v-model="hotelOrderSMS.choseSMSModel" :label=item.bookingStatus>
                    {{item.bookingStatus? $t("COMMONPARAM.ORDERSTATE." + item.bookingStatus): "" }}
                  </el-radio>
                  </div>
                  <div class="smsModelContent_div">
                    <div>
                      <span>{{ item.content }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- end hotelOrderSMS dialog -->

    <!-- begin otherProduct dialog -->
    <el-dialog class="price-dialog" v-model="isOtherProduct" :close-on-click-modal="false">
      <div class="form">
        <template>
            <div class="otherProduct_div" v-if="menuList != null && menuList.length > 0">
              <div>
                <span>{{ $t("OTHERPRODUCT.MSG") }}</span>
              </div>
              <el-row>
                <el-col :lg="8" v-for="(menu, index) in menuList" :key="menu.menuCode" :index="index.toString()">
                  <el-button style="min-width: 150px;" round @click="getSSOUrl(menu.menuCode)">{{$i18n.locale == "zh"? menu.menuName: menu.menuNameEn}}</el-button>
                </el-col>
              </el-row>
            </div>
          </template>
      </div>
    </el-dialog>
    <!-- end otherProduct dialog -->
    <!-- begin RefundInfo dialog -->
    <el-dialog :title="$t('REFUNDREQUESTINFO.REFUNDTITLE')" v-model="isShowRefundDialog" width="40rem">
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :model="orderInfo" :inline="true">
        <el-row>
          <el-col>
            <el-form-item :label="$t('REFUNDREQUESTINFO.CHECKINDATE')">
              <span>{{orderInfo.checkInDate}} </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item :label="$t('REFUNDREQUESTINFO.CHECKOUTDATE')">
              <span>{{orderInfo.checkOutDate}} </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item :label="$t('REFUNDREQUESTINFO.ROOMCHARGE')">
              <span>{{$currencySign[orderInfo.currencyCode] + " " + orderInfo.totalPrice}} </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col  v-for="(item, index) in orderInfo.roomStay" :key="index">
            <el-form-item class="refund-roomStay">
              <span>{{ showRoomStay(item)}} </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item :label="$t('REFUNDREQUESTINFO.FREE')">
              <span>{{$currencySign[orderInfo.currencyCode] + " " + orderInfo.serviceFees.amount}} </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item :label="$t('CONFIRMATION.EMERGENCY')">
              <span>{{$currencySign[orderInfo.currencyCode] + " " + orderInfo.emergencyServiceFee}} </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="refudeHint">
            <span v-html="$t('REFUNDREQUESTINFO.REFUNDMSG')"></span> 
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button class="footer-button" @click="confirmOrder"> 
          {{ $t("REFUNDREQUESTINFO.CONFIRMED") }}
        </el-button>
      </template>
    </el-dialog>
    <!-- end RefundInfo dialog -->
    <!-- begin RefundRequest dialog -->
    <el-dialog :title="$t('REFUNDREQUESTINFO.REFUNDREQUESTTITLE')" v-model="isShowRefundRequsetDialog" width="40rem">
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :model="refundRequestInfo" :inline="true" :rules="refundRules" ref="refundRequestInfo">
        <el-row>
          <el-col>
            <el-form-item :label="$t('REFUNDREQUESTINFO.SHOWDATEPICKER')">
              <el-checkbox v-model="refundRequestInfo.checked" @change="getRefundAmount"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('REFUNDREQUESTINFO.ACTUALCHECKINDATE')">
              <el-input size="default" v-model="refundRequestInfo.checkinDate" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item :label="$t('REFUNDREQUESTINFO.ACTUALCHECKOUTDATE')">
              <el-date-picker v-model="refundRequestInfo.checkoutDate" type="date" value-format="YYYY-MM-DD" :disabled-date="disabledCheckoutDate" :clearable="false" :disabled = "refundRequestInfo.checked"  @change="getRefundAmount"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item :label="$t('REFUNDREQUESTINFO.REFUNDREQUESTAMOUNT')" prop="totalAmount">
              <div style="display:flex;">
                <span style="padding-right:5px;">{{$currencySign[orderInfo.currencyCode]}}</span>
                <el-input size="default" v-model="refundRequestInfo.totalAmount" style="width:150px;"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="refudeHint">
            <span v-html="$t('REFUNDREQUESTINFO.REFUNDREQUESTMSG')"></span> 
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('REFUNDREQUESTINFO.REMARK')">
              <el-input type="textarea" v-model="refundRequestInfo.remark" maxlength="300" :rows="6" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div v-if="perPayDetails.refundStatus == 0 || perPayDetails.refundStatus == 1 || perPayDetails.refundStatus == 4">
          <el-button class="footer-button" @click="saveRefundInfo()"> 
            {{ $t("REFUNDREQUESTINFO.SUBMIT") }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <!-- end RefundInfo dialog -->
    <!-- 移动端重发行程单 start -->
    <van-action-sheet v-model:show="showH5ApprovedDialog" :title="$t('HOTELORDEREMAIL.APPROVEDINFO')" :closeable="false">
      <div style="padding: 2rem 2rem 2rem;">
        <van-form>
          <van-field v-model="hotelOrderEmail.hotelOrderEmailInfo.reciveEmail" :label="$t('HOTELORDEREMAIL.SUBSCRIBEREMAIL')"/>
          <van-field :placeholder="$t('HOTELORDEREMAIL.CHECKINEMAILTITLE')" v-model="hotelOrderEmail.hotelOrderEmailInfo.checkinEmail" :label="$t('HOTELORDEREMAIL.CHECKINEMAIL')"/>
          <van-field :placeholder="$t('CONFIRMATION.CCTITLE')" v-model="hotelOrderEmail.hotelOrderEmailInfo.ccEmail" :label="$t('HOTELORDEREMAIL.CCEMAIL')"/>
          <van-radio-group v-model="hotelOrderEmail.showEnTemplate" direction="horizontal" style="margin-top:1rem;">
            <van-radio name="1" style="font-size: 14px;">{{ $t("HOTELORDEREMAIL.CNNAME") }}</van-radio>
            <van-radio name="2" style="font-size: 14px;margin-left:2rem">{{ $t("HOTELORDEREMAIL.ENNAME") }}</van-radio>
          </van-radio-group>
          <div style="margin-top:2rem;">
            <van-button round block type="info" native-type="submit" style="background-color:#fc6640;border:1px solid #fc6640" @click="repeatEmail('H5')">{{ $t("HOTELORDEREMAIL.REPEAT") }}</van-button>
          </div>
        </van-form>
      </div>
    </van-action-sheet>
    <!-- 移动端重发行程单 end -->
  </div>
</template>

<script>
import {
  bookingDetail,
  cancelBooking,
  bookingsUpdate,
  getRemarkInfo,
  createRemarkInfo,
  updateServiceCharge,
  repeatItinerary,
  getPreviewItinerary,
  getConsul,
  getrefundlist,
  hoteltradeSaveRefund,
  calculateRefundAmount,
  confirmCompletion,
} from "../../api/bookingData.js";
import {
  getCustomerMI,
  pointSearch,
  getCustomerLookup,
  searchSMSModel,
  sendSMS,
  getUserGetUserMenuList,
  jumpLogin,
  serchHotelOrderEmail,
  getuserinfo,
  sanitizeJumpUrl,
} from "../../api/platformData.js";
import {
  formatDateTime,
  dateChange,
  getServerTimeAxios,
  hideElement,
  isCityGAT,
  getCityInfoByCode,
  isEmail,
  base64ToBlob,
  eval2,
} from "../../utils/utils.js";
import { groupList, } from "@/api/shoppingData";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import ConfirmationRight from "@/views/confirmation/confirmationRight.vue";
import ConfirmationSpecial from "@/views/confirmation/confirmationSpecial.vue";
import personnelInfo from "@/views/confirmation/personnelInfo.vue";
import Loading from "@/components/Loading.vue";
import axios from "axios";
import { json } from "body-parser";
import { ElMessageBox } from "element-plus";
import { showConfirmDialog } from "vant";

export default {
  name: "confirmation",
  components: {
    ConfirmBoxs,
    Loading,
    ConfirmationRight,
    ConfirmationSpecial,
    personnelInfo
  },
  provide() {
    return {
      OrderData: this,
      orderInfos: this.orderInfo,
    }
  },
  // watch:{
  //   "orderInfo.miInfoList": {
  //     handler(val,oldval){
  //       this.orderInfo.miInfoList = val;
  //     },
  //     deep:true,
  //   }
  // },
  data() {
    return {
      eval2:eval2,
      isUpdateServiceCharge: false,
      isUpdateEmergencyServiceCharge: false,
      isUpdateBreakfastQty: false,
      isUpdate: false,
      remarkFlag: false,
      cancleForm: {
        hotelConfirmRemark: "",
        hotelConfirmNo: "",
      },
      isRefresh: false,
      dialogBtnMsg: "",
      btnType: "",
      dialogBtnTitle: "",
      showUpdateOrderFlag: false,
      detailLoading: true,
      confirmFlag: false,
      confirmMsg: "",
      defaultImg:
        'this.src="' +
        require("@/assets/img/hotel_img_error.png") +
        '";this.onerror=null;',
      isbookBreadcrumb: true,
      isShowGuarantee: false,
      currentDate: ["2021-10-31 18:00"],
      centerDialogVisible: false,
      cancelDialogVisible: false,
      originData: [],
      columnLength: 0,
      transData: [],
      originTitle: [],
      showPriceFlag: false,
      
      
      
      hotelInfo: {
        name: { "zh-CN": "", en: "" },
        address: { "zh-CN": "", en: "" },
        photos: [],
      }, 
      orderInfo: {
        miInfoList:[],
        bookingAgent: [{ contact: {} }],
        cancellationRules: { cancellationPolicy: "", cancellationDate: "" },
        guestInfo: [{ contact: {} }],
        serviceFees: {},
        priceType: "",
        paymentInfo: {},
        source:"",
        emission:{kgOfCO2: 0, score: 0},
      },
      roomInfo: {},
      isShowCancel: false, //是否显示取消按钮
      isDomc: "D", //TC  D:国内  I:国际
      updateOrderForm: {},
      miListALl: [],
      miList: [],
      orderStatusList: [],
      orderStatusList: [],
      isShowUpdate: true, // CRM下是否显示修改按钮
      customerCode: "",
      showMobilePriceFlag: false,
      showMobilePriceFlag: false,
      //isShowTax: true, //是否显示税费
      //isShowOther: true, // 是否显示其他费用
      isGATCity: false, // 是否是港澳台城市
      taxesInfo: {
        //税费信息
        hasTax: false,
        taxAmount: 0,
        taxCurrency: "",
        others: 0,
        otherCurrency: "",
      },
      hotelOrderEmail: {
        showEmailFlag: false,
        showEnTemplate: "1",
        hotelOrderEmailInfo: {
          reciveEmail: "",
          checkinEmail: "",
          ccEmail: "",
          emailContent: "",
          subject: "",
          languageCode: "zh-CN",
        },
      },
      isShowBtn: this.$route.query.isShowBtn,
      remarkInfo: {
        showRemarkFlag: false,
        clientData: [],
      },
      emergencyServiceFee_original: "",
      serviceFees_original: "",
      breakfastQty_original: "",
      breakfastData:"",
      POSRCTextValue:"",
      isShowPOSRC:false,
      breakfastInfo: [
        { value: 0, label: this.$t("BOOKING.NOBREAKFAST"),},
        { value: 99, label: this.$t("BOOKING.BREAKFAST99"),},
        { value: 1, label: this.$t("BOOKING.BREAKFASTNUM", {num: 1,}),},
        { value: 2, label: this.$t("BOOKING.BREAKFASTNUM", {num: 2,}),},
        { value: 3, label: this.$t("BOOKING.BREAKFASTNUM", {num: 3,}),},
        { value: 4, label: this.$t("BOOKING.BREAKFASTNUM", {num: 4,}),},
        { value: 5, label: this.$t("BOOKING.BREAKFASTNUM", {num: 5,}),},
        { value: 100, label: this.$t("BOOKING.BREAKFASTUNKNOWN"),},
      ],
      repeatEmailLoading: false,
      isCompulsionShowCancel: false, //是否显示强制取消弹框
      hotelOrderSMS: {
        showSMSFlag: false,
        showEnTemplate: "1",
        choseSMSModel:"BOOKED",
        hotelOrderSMSInfo: [],
        repeatSMSLoading: false,
        smsLanguage:"CN",
        guestMobile:"",
        bookingAgentMobile:""
      },
      isOtherProduct: false,
      menuList: [],
      CityCodes:[],//港澳台城市code
      
      isShowSyncPnr:false,//是否显示同步酒店pnr按钮
      isShowSyncHotelConfirmationNo:false,//是否显示同步酒店确认单号按钮
      syncBookStatus:["BOOKED","CHECKOUT","NOSHOW"],//同步酒店pnr状态
      isShowUpdateHotelConfirmationNo:false,//是否显示修改酒店确认单号选线
      isServicefree: true,//是否显示服务费
      isAdvancepayment: true,//是否展示垫资费
      isUrgentfee: true,//是否展示紧急服务费
      OrderGuaranteeType:0,//担保类型
      isShowRefundDialog: false,
      isShowRefundRequsetDialog:false,
      refundRequestInfo:{
        checkinDate:"",
        checkoutDate:"",
        totalAmount:"0",
        remark:"",
        checked:false,
      },
      isShowPrepaidTips:false,//是否展示预付提示话术
      prepaidTips:'',//是否展示预付提示话术
      ChainwidePriceText:"",
      showH5ApprovedDialog:false,
      perPayDetails:{
        invoiceStatus: 0,
        isShowBilling:false,
        isShowFinishOrderBtn:false,
        isShowRefundBtn:false,
        refundRequestListDetail:{},
        refundStatus:0,
        serviceFeeTotal:0
      },
      groupid:"",
      intlTaxDisplay:"",
    };
  },
  created() {
    if (this.$objBaseInfo.channelId === "MOBILE") {
      this.$nextTick(() => {
        //不显示回退按钮
        let goHistray = document.querySelector(".van-nav-bar__left");
        goHistray.setAttribute("style", "display:none");
      });
    }
    if(this.$objBaseInfo.hasOwnProperty("posrc"))
    {
      let posrc=this.$objBaseInfo.posrc;
      if(posrc!=undefined && posrc!=null)
      {
        if(posrc.isShow!=undefined && posrc.isShow)
        {
          this.isShowPOSRC=true;
        }
        else
        {
          this.isShowPOSRC=false;
        }
      }
      else
      {
        this.isShowPOSRC=false;
      }
    }
    else
    {
      this.isShowPOSRC=false;
    }
    if(this.$objBaseInfo.sourceType != 'CRM'){
      if(this.$objBaseInfo.hasOwnProperty("posItineraryModel")){
        let posItinerary=this.$objBaseInfo.posItineraryModel;
        this.isServicefree = posItinerary.isServicefree;
        this.isAdvancepayment= posItinerary.isAdvancepayment;
        this.isUrgentfee= posItinerary.isUrgentfee;
      }
    }
  },
  computed:{
    // ChainwidePrice:function (){
    //   if (this.orderInfo.extendInfo.length > 0) {
    //       let negotiationPriceType=this.orderInfo.extendInfo.find(item => item.name == "negotiationPriceType");
    //       if(negotiationPriceType!=null && negotiationPriceType!=undefined)
    //       {
    //         if(negotiationPriceType.valueInfo.length>0){
    //           let negotiationPriceTypeText=negotiationPriceType.valueInfo[0]["negotiationPriceType"];
    //           if(negotiationPriceTypeText=="ratio")
    //           {
    //             return this.$t('DETAIL.ChainwidePrice')
    //           }
    //         }
    //       }
    //   }
    //   return "";
    // },
    bookingType:function (){
      const extendInfo = this.orderInfo && Array.isArray(this.orderInfo.extendInfo) ? this.orderInfo.extendInfo : [];
      if (extendInfo.length > 0) {
          let bookingType=extendInfo.find(item => item.name == "bookingType");
          if(bookingType!=null && bookingType!=undefined)
          {
            if(bookingType.valueInfo && bookingType.valueInfo.length>0){
              let bookingTypeText=bookingType.valueInfo[0]["bookingType"];
              return bookingTypeText;
            }
          }
      }
      return "";
    },
    smsRules() {
      return {
        bookingAgentMobile: [
          { required: true, validator: this.validateMobile, trigger: ["blur", "change"], },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t("MANUAL.VALIDATEPHONEFORMAT"), trigger: ["blur", "change"], },
        ],
        guestMobile: [
          { pattern: /^1[3-9]\d{9}$/, message: this.$t("MANUAL.VALIDATEPHONEFORMAT"), trigger: ["blur", "change"], },
          { required: true, validator: this.validateMobile, trigger: ["blur", "change"], },
        ]
      }
    },
    //获取客服电话
    getCustomPhone()
    {
      let customerPhone="";
      //elong渠道的订单 获取服务组电话 规则：linkType=1  
      let isdomc=this.orderDetail.isInternational?"I":"D";//获取国内国际
  
      if(this.CityCodes.length>0 && this.CityCodes.indexOf(this.orderDetail.cityCode)>=0)//港澳台城市当作国内城市判断
      {
        isdomc="I";
      }
      if(this.$objBaseInfo.customerTcs!=undefined &&this.$objBaseInfo.customerTcs!=null)
      {
        let customerTcsArr=this.$objBaseInfo.customerTcs.filter(item=>item.linkType==1 && item.isDomc.indexOf(isdomc)>=0);
        if(customerTcsArr.length>0)
        {
          if(customerTcsArr.length==1)
          {
            customerPhone=customerTcsArr[0].keyValue;
          }
          else if(customerTcsArr.length>1)
          {
            customerTcsArr=customerTcsArr.sort((a,b)=>{ return a.sortId-b.sortId});
            customerPhone=customerTcsArr[0].keyValue;
          }
        }
      }
      return customerPhone;
    },
    showRoomStay(){
      return (roomStay) => {
        const currencyCode = roomStay?.currencyCode || "";
        const currencySign = this.$currencySign?.[currencyCode] || currencyCode;
        return formatDateTime(roomStay?.stayDate, "YYYY-MM-DD") + " :  " + currencySign + "  " + (roomStay?.publishedFare ?? "");
      };
    },
    refundRules() {
      return {
        totalAmount: [
          { required: true, message: this.$t("REFUNDREQUESTINFO.VALIDATEAMOUNT"), trigger: ["blur", "change"], },
          { required: true, validator: this.validateRefundAmount, trigger: ["blur", "change"], }],
      };
    },
    getInvoiceStatus(){
      return () => {
        const type = this.perPayDetails?.invoiceStatus ?? 0;
        switch (type) {
          case 0:
            return this.$t("INVOICINGSTATUS.INVOICINGSTATUS0");
          case 1:
          case 3:
            return this.$t("INVOICINGSTATUS.INVOICINGSTATUS2");
          case 2:
            return this.$t("INVOICINGSTATUS.INVOICINGSTATUS1");
          default:
            return "";
        }
      };
    },
    convertOrderStatus(){
      return () => {
        const orderInfo = this.orderInfo || {};
        var status = orderInfo.bookingStatus || "";
        if(status == 'CWT_PENDING_APPROVAL' && orderInfo.approvalStatus == 0){
          return 'CWT_PENDING_SUBMISSION';
        }
        return status
      };
    },
    convertCancellationDate(){
      return () => {
        const orderInfo = this.orderInfo || {};
        const source = orderInfo.source || "";
        const cancellationRules = orderInfo.cancellationRules || {};
        const cancellationDate = cancellationRules.cancellationDate || "";
        if(source.indexOf('sabre')>=0 && this.isDomc == "I" && !this.isGATCity){
          return cancellationDate + this.$t("CONFIRMATION.LocalTime");
        }
        if(source.indexOf('booking')>=0 && this.isDomc == "I" && !this.isGATCity){
          return cancellationDate + this.$t("CONFIRMATION.BeijingTime");
        }
        return cancellationDate;
      };
    },
  },
  mounted() {
    //判断来源 CRM跳转过来隐藏部分元素
    hideElement(this);
    //crm 获取customerCode 然后获取poscode, tc小组信息
    //getCustomerLookup
    if (
      this.$objBaseInfo.sourceType == "CRM" &&
      this.$route.query.customerCode
    ) {
      this.customerCode = this.$route.query.customerCode;
      this.getPosCode();
    } 
    // else {
    //   this.getMiList();
    // }
    this.orderDetail();
  },
  methods: {
    getPosCode() {
      let params = {
        params: {
          customerCode: this.customerCode,
          channelID: "WEB",
        },
      };
      axios
        .all([getCustomerLookup(params), pointSearch(params)])
        .then(
          axios.spread((customer, point) => {
            //公司信息
            if (customer.code === 200) {
              if (customer.data.customerDetails.length > 0) {
                let cusInfo = customer.data.customerDetails[0];
                this.$objBaseInfo.customerTcs = cusInfo.customerTcs; //tc服务小组
              }
            } else {
              console.log("公司信息err:", customer);
            }
            //Point Sale信息
            if (point.code === 200) {
              if (point.data.list.length > 0) {
                let posData = point.data.list[0];
                this.$objBaseInfo.poscode = posData.poscode;
              } else {
                console.log("CRM请选择其他客户名称");
              }
            } else {
              console.log("Point Sale error:", point);
            }
            //this.getMiList();
          })
        )
        .catch(function (error) {
          console.log("公司信息和Point Sale信息 请求失败", error.objError);
        });
    },
    
    async orderDetail() {
      const bookingId = this.$route.query.orderId;
      let orderParam = {
        params: {
          bookingId: bookingId,
          posCode: this.$objBaseInfo.poscode,
          returnDescriptiveInfo: true,
        },
      };
      // this.detailLoading = false;
      let that = this;
      await bookingDetail(orderParam)
        .then((res) => {
          that.detailLoading = false;
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              this.confirmFlag = true;
              this.confirmMsg =
              this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "订单获取失败, code:" , res.data.error.code,
                res.data.error.message
              );
            } else {
              if (res.data.guestInfo && res.data.guestInfo.length > 0) {
                res.data.guestInfo.forEach((guest) => {
                  // 检查 contact 和 linkerInfo 是否存在
                  if (guest.contact?.linkerInfo) {
                    try {
                      // 解析 linkerInfo 字符串为对象，并直接修改原数据
                      guest.contact.linkerInfo = JSON.parse(guest.contact.linkerInfo);
                      guest.contact.showLinker = true;
                    } catch (error) {
                    }
                  }else{
                    guest.contact.showLinker = false;
                  }
                });
              }
              that.orderInfo = res.data;
              let miListALl=[];
              if(Object.prototype.hasOwnProperty.call(res.data, "customerMIResp")) 
              {
                miListALl = res.data.customerMIResp.items;
              }
              if (miListALl.length > 0) {
                this.miList = miListALl;
                let formU = {};
                for (const item of this.miList) {
                  formU[item.relationMIKey] = "";
                  const element = item;
                  if(element!=null && element!=undefined && element!="")
                  {
                    element.note="";
                    element.noteLink="javascript:void(0)";
                    if(this.$i18n.locale == "en")
                    {
                      if(element.noteEN!=undefined && element.noteEN!=null && element.noteEN!="")
                      {
                        element.note=element.noteEN;
                      }
                      if(element.noteENLink!=undefined && element.noteENLink!=null && element.noteENLink!="")
                      {
                        element.noteLink=element.noteENLink;
                      }
                    }
                    else
                    {
                      if(element.noteCN!=undefined && element.noteCN!=null && element.noteCN!="")
                      {
                        element.note=element.noteCN;
                      }
                      if(element.noteCNLink!=undefined && element.noteCNLink!=null && element.noteCNLink!="")
                      {
                        element.noteLink=element.noteCNLink;
                      }
                    }
                  }
                }
                this.updateOrderForm = formU; //赋值
                if (this.$refs.updateOrderForm) {
                  this.$nextTick(() =>
                    this.$refs.updateOrderForm.clearValidate()
                  );
                }
              } else {
                this.miList = [];
              }
              if(Object.prototype.hasOwnProperty.call(res.data, "perPayDetails")) 
              {
                that.perPayDetails = res.data.perPayDetails;
              }
              that.OrderGuaranteeType = that.orderInfo.guaranteeType;
              if (that.orderInfo.extendInfo.length > 0) {
                  let negotiationPriceType=that.orderInfo.extendInfo.find(item => item.name == "negotiationPriceType");
                  if(negotiationPriceType!=null && negotiationPriceType!=undefined)
                  {
                    if(negotiationPriceType.valueInfo.length>0){
                      let negotiationPriceTypeText=negotiationPriceType.valueInfo[0]["negotiationPriceType"];
                      if(negotiationPriceTypeText=="ratio")
                      {
                        that.ChainwidePriceText=that.$t('DETAIL.ChainwidePrice')
                      }
                    }
                  }
                  let intlTaxDisplayInfo = that.orderInfo.extendInfo.find(item => item.name == "intlTaxDisplayInfo");
                  if(intlTaxDisplayInfo!=null && intlTaxDisplayInfo!=undefined){
                    if(intlTaxDisplayInfo.valueInfo.length>0){
                      that.intlTaxDisplay = intlTaxDisplayInfo.valueInfo[0]["intlTaxDisplay"];
                    }
                  }
              }

              // 无需担保判断是否late担保
              if(that.orderInfo.guaranteeType==3)
              {
                if(that.orderInfo.paymentInfo.creditCardNumber!=undefined && that.orderInfo.paymentInfo.creditCardNumber!=null && that.orderInfo.paymentInfo.creditCardNumber!="")
                {
                  that.OrderGuaranteeType=4;
                }
              }
              if(res.data.bookingStatus == "BOOKED" && this.$objBaseInfo.showOtherProduct && this.$objBaseInfo.sourceType == "OBT"){
                this.getMenu();
              }
              //that.LoadCostCenter();
              that.emergencyServiceFee_original =
                this.orderInfo.emergencyServiceFee;
              that.serviceFees_original = this.orderInfo.serviceFees.amount;
              if(Object.prototype.hasOwnProperty.call(this.orderInfo, "breakfastQuantityCwt")){
                that.breakfastQty_original = this.orderInfo.breakfastQuantityCwt;
                that.breakfastData = this.orderInfo.breakfastQuantityCwt;
              }
              else
              {
                if (Object.prototype.hasOwnProperty.call(this.orderInfo, "sabreBreakfast")) {
                  let qty = this.orderInfo.sabreBreakfast ? 99 : 0;
                  that.breakfastQty_original = qty;
                  that.breakfastData = qty;
                } else {
                  that.breakfastQty_original = this.orderInfo.breakfastQty;
                  that.breakfastData = this.orderInfo.breakfastQty;
                }
              }
              
              that.isUpdateServiceCharge = false; 
              if (
                res.data.paymentType == 1 &&
                this.$objBaseInfo.sourceType == "CRM" && that.orderInfo.serviceFees.amount <= 0
              ) {
                that.isUpdateServiceCharge = true; 
              }

              that.isUpdateEmergencyServiceCharge = false;
              if (
                res.data.paymentType == 1 &&
                this.$objBaseInfo.sourceType == "CRM" && that.orderInfo.emergencyServiceFee <= 0
              ) {
                that.isUpdateEmergencyServiceCharge = true; 
              }
              
              if (this.$objBaseInfo.sourceType == "CRM" && that.orderInfo.isManualOrder != null &&
                    that.orderInfo.isManualOrder != undefined  && that.orderInfo.isManualOrder == true) {
                that.isUpdateBreakfastQty = true;
              }
              //时间转换
              that.orderInfo.checkOutDate = formatDateTime(that.orderInfo.checkOutDate,"YYYY-MM-DD");
              that.orderInfo.checkInDate = formatDateTime(that.orderInfo.checkInDate,"YYYY-MM-DD");
              that.orderInfo.creationDate = formatDateTime(that.orderInfo.creationDate,"YYYY-MM-DD HH:mm:ss");
              //IsInternational 是否是国际订单
              // if (that.orderInfo.isInternational) {
              //   that.isDomc = "I";
              // } else {
              //   that.isDomc = "D";
              // }
               //MI
               for (const key in that.orderInfo.miInfoList) {
                  const element = that.orderInfo.miInfoList[key];
                  let miDrop = that.miList.find((item) => {
                    if (item.relationMIKey == element.miKey) {
                      return item;
                    } else {
                      return null;
                    }
                  });
                  if (miDrop) {
                    if (miDrop.textTypeCode == "down") {
                      let miDropName = miDrop.dropDowns.find((drop) => {
                        if (drop.downCode == element.miValue) {
                          return drop;
                        }
                      });
                      if (miDropName) {
                        that.orderInfo.miInfoList[key].miDropName = {
                          en: miDropName.nameEN,
                          "zh-CN": miDropName.nameCN,
                        };
                      } else {
                        that.orderInfo.miInfoList[key].miDropName = {
                          en: "",
                          "zh-CN": "",
                        };
                      }
                    }
                    if (that.$objBaseInfo.sourceType == "OBT") {
                      that.orderInfo.miInfoList[key].pageShow = miDrop.pageShow;
                    } else {
                      that.orderInfo.miInfoList[key].pageShow = 1;
                    }
                  }
                  if (element.miValue) {
                    that.updateOrderForm[element.miKey] = element.miValue;
                  } else {
                    that.updateOrderForm[element.miKey] = "";
                  }
                  if(element!=null && element!=undefined && element!="")
                  {
                    element.note="";
                    element.noteLink="javascript:void(0)";
                    if(that.$i18n.locale == "en")
                    {
                      if(element.noteEN!=undefined && element.noteEN!=null && element.noteEN!="")
                      {
                        element.note=element.noteEN;
                      }
                      if(element.noteENLink!=undefined && element.noteENLink!=null && element.noteENLink!="")
                      {
                        element.noteLink=element.noteENLink;
                      }
                    }
                    else
                    {
                      if(element.noteCN!=undefined && element.noteCN!=null && element.noteCN!="")
                      {
                        element.note=element.noteCN;
                      }
                      if(element.noteCNLink!=undefined && element.noteCNLink!=null && element.noteCNLink!="")
                      {
                        element.noteLink=element.noteCNLink;
                      }
                    }
                  }
                }
                //扩展字段 特殊需求
                if (that.orderInfo.extendInfo.length > 0) {
                  for (const iterator of that.orderInfo.extendInfo) {
                    if (iterator.name == "Special") {
                      if (iterator.valueInfo.length == 1) {
                        that.orderInfo.special1 = iterator.valueInfo[0];
                      } else if (iterator.valueInfo.length == 2) {
                        that.orderInfo.special1 = iterator.valueInfo[0];
                        that.orderInfo.special2 = iterator.valueInfo[1];
                      } else {
                        that.orderInfo.specialRequests = "";
                      }
                      break;
                    } else {
                      that.orderInfo.specialRequests = "";
                    }
                  }
                } else {
                  that.orderInfo.specialRequests = "";
                }
                //间夜数
                const constNight =
                  (new Date(that.orderInfo.checkOutDate).getTime() -
                    new Date(that.orderInfo.checkInDate).getTime()) /
                  (24 * 60 * 60 * 1000);
                that.orderInfo.nights = constNight;
                                //取消政策
                                try {
                  if (
                    that.orderInfo.cancellationRules.cancellationPolicy == 2 ||
                    that.orderInfo.cancellationRules.cancellationPolicy == 1
                  ) {
                    //限时取消
                    if (
                      that.orderInfo.cancellationRules.cancellationPolicy ==
                        1 ||
                      that.orderInfo.cancellationRules.deadlineDay == 0
                    ) {
                      //没有提前天数
                      that.orderInfo.cancellationRules.cancellationDate =
                        that.orderInfo.checkInDate +
                        " " +
                        that.orderInfo.cancellationRules.deadlineTime +
                        ":00";
                    } else {
                      that.orderInfo.cancellationRules.cancellationDate =
                        dateChange(
                          parseInt(
                            "-" + that.orderInfo.cancellationRules.deadlineDay
                          ),
                          that.orderInfo.checkInDate
                        ) +
                        " " +
                        that.orderInfo.cancellationRules.deadlineTime +
                        ":00";
                    }
                  } else {
                    that.orderInfo.cancellationRules.cancellationDate =
                      that.orderInfo.checkInDate;
                  }
                  if (
                    that.orderInfo.isCancelable ||
                    (that.orderInfo.bookingStatus ==
                      "CWT_PENDING_CANCELLATION" &&
                      this.$objBaseInfo.sourceType == "CRM")
                  ) {
                    that.isShowCancel = true;
                   
                  } else {
                    that.isShowCancel = false;
                  }
                  // CHOM-3565:未提交的待审批订单才能取消，已提交的无法取消
                  if(that.orderInfo.bookingStatus ==
                    "CWT_PENDING_APPROVAL" &&
                    this.orderInfo.approvalStatus ==0)
                  {
                    that.isShowCancel = true;
                  }
                } catch (exErr) {
                  console.log("取消政策计算异常" , exErr);
                }

              // 赋值全部city 信息
              getCityInfoByCode(that.orderInfo.cityCode).then((city) => {
                if (city) {
                  that.isGATCity = isCityGAT(city.provinceCode);
                }
                //IsInternational 是否是国际订单
                if (that.orderInfo.isInternational || that.isGATCity) {
                  that.isDomc = "I";
                } else {
                  that.isDomc = "D";
                }
              
                that.orderInfo.otherRequirement = ""; //其他需求
                let RoomStay = []; //间夜信息
                that.originData = [];
                if (that.orderInfo.roomStay instanceof Array) {
                  RoomStay = that.orderInfo.roomStay;
                } else {
                  RoomStay.push(that.orderInfo.roomStay);
                }
                // if ((that.isDomc == "I" || that.isGATCity) && RoomStay.length > 0) {
                //   let element = RoomStay[0];
                //   if (element.Taxs && element.Taxs.Amount) {
                //     that.isShowTax = true;
                //   } else {
                //     that.isShowTax = false;
                //   }
                //   if (element.OtherFees && element.OtherFees.Amount) {
                //     that.isShowOther = true;
                //   } else {
                //     that.isShowOther = false;
                //   }
                // }
                for (const element of RoomStay) {
                  let price = {
                    date: formatDateTime(element.stayDate,"YYYY-MM-DD"),
                    price:
                      (this.$currencySign[that.orderInfo.currencyCode]
                        ? this.$currencySign[that.orderInfo.currencyCode]
                        : that.orderInfo.currencyCode) + element.publishedFare,
                  };
                  that.originData.push(price);
                }
                if (that.isDomc == "I" || that.isGATCity) {
                  // if (element.Taxs && element.Taxs.Amount) {
                  //   price.tax = (this.$currencySign[element.Taxs.CurrencyCode]?this.$currencySign[element.Taxs.CurrencyCode]:element.Taxs.CurrencyCode) + element.Taxs.Amount;
                  // }
                  // if (element.OtherFees && element.OtherFees.Amount) {
                  //   price.fee = (this.$currencySign[element.OtherFees.CurrencyCode]?this.$currencySign[element.OtherFees.CurrencyCode]:element.OtherFees.CurrencyCode) + element.OtherFees.Amount;
                  // }
                  if (that.orderInfo.taxes.amount !== null) {
                    this.taxesInfo.taxAmount = that.orderInfo.taxes.amount;
                    this.taxesInfo.taxCurrency = that.orderInfo.taxes
                      .currencyCode
                      ? this.$currencySign[that.orderInfo.taxes.currencyCode]
                      : "";
                    this.taxesInfo.hasTax = true;
                  }
                  if (that.orderInfo.fees.amount !== null) {
                    this.taxesInfo.others = that.orderInfo.fees.amount;
                    this.taxesInfo.otherCurrency = that.orderInfo.fees
                      .currencyCode
                      ? this.$currencySign[that.orderInfo.fees.currencyCode]
                      : "";
                    this.taxesInfo.hasTax = true;
                  }
                }
                //酒店信息
                that.hotelInfo = that.orderInfo.hoteDescriptiveInfo;
                that.hotelInfo.cover =
                  that.hotelInfo.cover == null
                    ? require("@/assets/img/hotel_img_error.png")
                    : that.hotelInfo.cover;
                //房间信息
                that.roomInfo = that.orderInfo.roomDescriptiveInfo;

                //修改订单是否显示
                if (that.orderInfo.bookingStatus != "BOOKED") {
                  that.isShowUpdate = false;
                } else {
                  that.isShowUpdate = true;
                }

                //强制取消的逻辑：取消订单按钮取消之后   现付的订单   Booked状态的    CRM可以取消  非补单的
                if(!that.orderInfo.isManualOrder && !that.isShowCancel && this.$objBaseInfo.sourceType == "CRM" && that.orderInfo.bookingStatus =="BOOKED" && that.orderInfo.paymentInfo.paymentType == '1')
                {
                  let compulsionCancelSource=[];
                  if(that.orderInfo.compulsionCancelSource!=undefined && that.orderInfo.compulsionCancelSource!=null)
                  {
                    compulsionCancelSource=that.orderInfo.compulsionCancelSource;
                  }
                  if(compulsionCancelSource.length>0)
                  {
                    if(compulsionCancelSource.indexOf(that.orderInfo.source.toLowerCase())>=0)
                    {
                      that.isCompulsionShowCancel = false;
                    }
                    else
                    {
                      that.isCompulsionShowCancel = true;
                    }
                  }
                }
                else
                {
                  that.isCompulsionShowCancel = false;
                }

                if(!that.orderInfo.isManualOrder && this.$objBaseInfo.sourceType == "CRM" && that.syncBookStatus.indexOf(that.orderInfo.bookingStatus)>-1)
                {
                  //判断是否显示酒店确认单号同步按钮
                  if(that.orderInfo.hotelConfirmationNo==undefined || that.orderInfo.hotelConfirmationNo==null || that.orderInfo.hotelConfirmationNo=="")
                  {
                    that.isShowSyncHotelConfirmationNo=true;
                  }
                  else
                  {
                    that.isShowSyncHotelConfirmationNo=false;            
                  }
                  
                   //判断是否显示pnr同步按钮
                  if(that.orderInfo.sourceBookingId==undefined || that.orderInfo.sourceBookingId==null || that.orderInfo.sourceBookingId=="")
                  {
                    that.isShowSyncPnr=true;
                  }
                  else
                  {
                    that.isShowSyncPnr=false;
                  }
                }
                else
                {
                  that.isShowSyncHotelConfirmationNo=false;     
                  that.isShowSyncPnr=false;       
                }
                
                if(that.orderInfo.source=="CWTbur" && this.$objBaseInfo.sourceType == "CRM" && that.syncBookStatus.indexOf(that.orderInfo.bookingStatus)>-1)
                {
                  that.isShowSyncHotelConfirmationNo=false;   
                  that.isShowUpdateHotelConfirmationNo=true;
                }

                //获取RC规则 
                let ReasonCodeFlag = that.orderInfo.extendInfo.some(animal => animal.name === "ReasonCode")
                if(that.isShowPOSRC && ReasonCodeFlag)
                {
                  that.isShowPOSRC=true;
                  let reasonCode=that.orderInfo.extendInfo.filter((item)=>{
                      return  item.name==="ReasonCode"
                  });
                  if(reasonCode!=null && reasonCode!=undefined && reasonCode.length>0)
                  {
                    let posrc=this.$objBaseInfo.posrc;
                    if(reasonCode[0].valueInfo.length>0 &&reasonCode[0].valueInfo[0].hasOwnProperty("reasonCodeValue") && reasonCode[0].valueInfo[0].hasOwnProperty("reasonCodeValueText"))
                    {
                      let code=reasonCode[0].valueInfo[0].reasonCodeValue;
                      let reasonCodeValueText=reasonCode[0].valueInfo[0].reasonCodeValueText;
                      if(reasonCodeValueText!=undefined && reasonCodeValueText!=null && reasonCodeValueText!="")
                      {
                        let arrText=reasonCodeValueText.split(',');
                        let compliance=[];
                        compliance.push(code);
                        compliance.push(arrText[0]);
                        compliance.push(arrText[1]);
                        that.POSRCTextValue=compliance.join('-');
                      }
                      else
                      {
                        const arrText=posrc.text.split(',');
                        let compliance = arrText.filter(function (val)  { return (code.indexOf(val.split('-')[0]) > -1) })
                        if(compliance.length>0)
                        {
                          that.POSRCTextValue=compliance[0];
                        }
                        else
                        {
                          that.POSRCTextValue=code;
                        }
                      }
                    }
                    else
                    {
                      that.isShowPOSRC=false;
                    }
                  }
                  else
                  {
                    that.isShowPOSRC=false;
                  }
                }
                else
                {
                  that.isShowPOSRC=false;
                }
              });
            }
            //跳转elong担保页面
            if(that.orderInfo.source == 'elong' && that.orderInfo.paymentInfo.paymentType == 1 && !that.orderInfo.elongPayFinish
            && that.orderInfo.reservationType == 0 && that.orderInfo.bookingStatus == 'PENDING_CONFIRMATION')
            {
              if(that.$route.query.isJumpLink == undefined || that.$route.query.isJumpLink == null)
              {
                that.elongLink();
              }
            }
            //that.payLink();
          } else {
            that.confirmFlag = true;
            that.confirmMsg =
              that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? that.$t("ERRORMESSAGE.NOTFOUND")
                : that.$t("ERRORMESSAGE." + res.code);
            console.log("订单详情查询失败,code:" , res.code, res.message);
          }
        })
        .catch((err) => {
          that.detailLoading = false;
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + err.mesCode);
          console.log("订单详情查询异常:", err.objError);
          that.orderInfo.cancellationRules = {
            CancellationPolicy: "",
            cancellationDate: "",
          };
          that.orderInfo.guestInfo = [{ Contact: {} }];
          that.orderInfo.bookingAgent = [{ Contact: {} }];
        });
    },
    setConfirmFlag() {
      this.confirmFlag = false;
      if (this.isRefresh || this.isUpdate) {
        this.isRefresh = false;
        this.isUpdate = false;
        this.orderDetail();
      }
    },
    
    
    showApprovedDialog(val) {
      if(val== "PC"){
        this.hotelOrderEmail.showEmailFlag = true;
      }else{
        this.showH5ApprovedDialog = true;
      }
      let hotelOrderEmailParam = {
        params: {
          bookingId: this.orderInfo.bookingId, //'H_10223142109029718',//
        },
      };
      getPreviewItinerary(hotelOrderEmailParam).then((res) => {
        if (res.code === 200) {
          if(res.data){
            this.hotelOrderEmail.hotelOrderEmailInfo = res.data;
            var patten = new RegExp("[\u4E00-\u9FA5]"); //判断是否包含中文
            if (patten.test(res.data.subject)) {
              this.hotelOrderEmail.showEnTemplate = "1";
            } else {
              this.hotelOrderEmail.showEnTemplate = "2";
            }
          }
        }
      });
    },
    repeatEmail(val) {
      if (!this.hotelOrderEmail.hotelOrderEmailInfo.reciveEmail && !this.hotelOrderEmail.hotelOrderEmailInfo.checkinEmail) {
        if(val == "PC"){
          this.confirmFlag = true;
          this.confirmMsg = this.$t("MANUAL.VALIDATEEMAIL");
        }else{
          this.$dialog.alert({
            message: this.$t("MANUAL.VALIDATEEMAIL"),
          });
        }
        return;
      } else {
        var reciveEmailTemp = [];
        var ccEmailTemp = [];
        if (this.hotelOrderEmail.hotelOrderEmailInfo.reciveEmail) {
          var reciveEmails =
            this.hotelOrderEmail.hotelOrderEmailInfo.reciveEmail.split(",");
          for (var i = 0; i < reciveEmails.length; i++) {
            if (!isEmail(reciveEmails[i])) {
              if(val == "PC"){
                this.confirmFlag = true;
                this.confirmMsg = this.$t("USERDIALOG.GUESTEMAIL2");
              }else{
                this.$dialog.alert({
                  message: this.$t("USERDIALOG.GUESTEMAIL2"),
                });
              }
              return;
            }
            reciveEmailTemp.push(reciveEmails[i]);
          }
        }
        if (this.hotelOrderEmail.hotelOrderEmailInfo.checkinEmail) {
          var checkInEmails =
            this.hotelOrderEmail.hotelOrderEmailInfo.checkinEmail.split(",");
          for (var i = 0; i < checkInEmails.length; i++) {
            if (!isEmail(checkInEmails[i])) {
              if(val == "PC"){
                this.confirmFlag = true;
                this.confirmMsg = this.$t("USERDIALOG.GUESTEMAIL2");
              }else{
                this.$dialog.alert({
                  message: this.$t("USERDIALOG.GUESTEMAIL2"),
                });
              }
              return;
            }
            reciveEmailTemp.push(checkInEmails[i]);
          }
        }
        if (this.hotelOrderEmail.hotelOrderEmailInfo.ccEmail) {
          var ccEmails =
            this.hotelOrderEmail.hotelOrderEmailInfo.ccEmail.split(",");
          for (var i = 0; i < ccEmails.length; i++) {
            if (!isEmail(ccEmails[i])) {
              if(val == "PC"){
                this.confirmFlag = true;
                this.confirmMsg = this.$t("USERDIALOG.GUESTEMAIL2");
              }else{
                this.$dialog.alert({
                  message: this.$t("USERDIALOG.GUESTEMAIL2"),
                });
              }
              return;
            }
            ccEmailTemp.push(ccEmails[i]);
          }
        }
        let repeatHotelOrderEmailReq = {
          LanguageCode: this.hotelOrderEmail.showEnTemplate== "2" ? "en" : "zh-CN",
          bookingId: this.orderInfo.bookingId,
          reciveEmail: reciveEmailTemp,
          cCEmail: ccEmailTemp,
        };
        this.repeatEmailLoading = true;
        repeatItinerary(repeatHotelOrderEmailReq).then((res) => {
          if (res.code === 200) {
            if(val == "PC"){
              this.hotelOrderEmail.showEmailFlag = false;
              this.confirmFlag = true;
              this.confirmMsg = this.$t("HOTELORDEREMAIL.REPEATMSG");
            }else{
              this.showH5ApprovedDialog = false;
              this.$dialog.alert({
                message: this.$t("HOTELORDEREMAIL.REPEATMSG"),
              });
            }
            
          }
          this.repeatEmailLoading = false;
        })
        .catch(function () {
          this.repeatEmailLoading = false;
        });
      }
    },
    //点击返回按钮--返回至list页面
    BackOrderList() {
      this.$router.push({
        name: "orderList",
        query: {
          searchParam: this.$store.state.listSearch.searchParam,
          sourceType: this.$store.state.listSearch.sourceType,
          menuType: this.$store.state.listSearch.menuType,
          lang: this.$store.state.listSearch.lang,
          token: this.$store.state.listSearch.token,
          isOpenBigOrder: this.$store.state.listSearch.isOpenBigOrder,
          isShowList: true,
        },
      });
    },
    async showRemarkDialog() {
      this.remarkInfo.showRemarkFlag = true;
      var arrTemp = [];
      let that = this;
      let remarkLogParam = {
        params: {
          bookingCode: this.orderInfo.bookingId,
        },
      };
      await getRemarkInfo(remarkLogParam)
        .then((res) => {
          if (res.code == 200) {
            if (res.data != null) {
              for (var i = 0; i < res.data.length; i++) {
                var response = res.data[i];
                const item = {
                  Date: formatDateTime(
                    new Date(response.date),
                    "yyyy-MM-dd HH:mm:ss"
                  ),
                  Detail: response.detail,
                  Operator: response.operator,
                };
                arrTemp.push(item);
              }
            }
            that.remarkInfo.clientData = arrTemp;
          }
        })
        .catch(function (error) {
          console.log("备注日志 请求失败", error);
        });
    },
    async addRemark() {
      this.$prompt(this.$t("REMARKINFO.ADDREMARKMSG"), "", {
        confirmButtonText: this.$t("MESSAGE.CONFIRMBUTTONTEXT"),
        cancelButtonText: this.$t("MESSAGE.CONFIRMCANCELTEXT"),
        inputType: "textarea",
        inputValidator(value) {
          if (value == undefined) {
            return "备注信息不能为空";
          } else if (value.length > 300) {
            return "只能输入300字符";
          }
        },
      }).then(({ value }) => {
        let remarkLogParam = {
          BookingCode: this.orderInfo.bookingId,
          Detail: value,
        };
        createRemarkInfo(remarkLogParam)
          .then((res) => {
            if (res.code == 200) {
              if (!res.data) {
                this.confirmFlag = true;
                this.confirmMsg = this.$t("REMARKINFO.ADDERRORMSG");
              } else {
                this.showRemarkDialog();
              }
            }
          })
          .catch(function (error) {
            console.log("备注日志 请求失败", error);
          });
      });
    },
    // 1:早餐数量 2：服务费 3：紧急服务费
    updateServiceChargeAndBreakfastQty(type) {
      var tips = this.$t("SERVICECHARGEINFO.TIPS");
      if (type == 1){
        tips = tips + "早餐?";
      }
      
      if (type == 2){
        tips = tips + "服务费?";
      }

      if (type == 3){
        tips = tips + "紧急服务费?";
      }

      this.$confirm(tips,
        this.$t("SERVICECHARGEINFO.HINT"),
        {
          confirmButtonText: this.$t("MESSAGE.CONFIRMBUTTONTEXT"),
          cancelButtonText: this.$t("MESSAGE.CONFIRMCANCELTEXT"),
          type: "warning",
        }
      )
        .then(() => {
          this.orderInfo.emergencyServiceFee =
            this.orderInfo.emergencyServiceFee == ""
              ? 0
              : this.orderInfo.emergencyServiceFee;
          this.orderInfo.serviceFees.amount =
            this.orderInfo.serviceFees.amount == ""
              ? 0
              : this.orderInfo.serviceFees.amount;
          this.orderInfo.breakfastQty =
            this.orderInfo.breakfastQty == ""
              ? 0
              : this.orderInfo.breakfastQty;
          if (
            this.orderInfo.emergencyServiceFee !=
              this.emergencyServiceFee_original ||
            this.orderInfo.serviceFees.amount != this.serviceFees_original||
            this.orderInfo.breakfastQty != this.breakfastQty_original
          ) {
            let serviceChargeParam = {
              BookingCode: this.orderInfo.bookingId,
              BookingStatus: this.orderInfo.bookingStatus,
              EmergencyServiceFee: this.orderInfo.emergencyServiceFee,
              ServiceFees: this.orderInfo.serviceFees.amount,
              BreakfastInfo: this.orderInfo.breakfastQty,
              EmergencyServiceFee_original: this.emergencyServiceFee_original,
              BreakfastInfo_original: this.breakfastQty_original,
            };
            updateServiceCharge(serviceChargeParam)
              .then((res) => {
                if (res.code == 200) {
                  if (!res.data) {
                    this.confirmFlag = true;
                    this.confirmMsg = this.$t(
                      "SERVICECHARGEINFO.SERVICECHARGEERROR"
                    );
                    this.orderDetail();
                  } else {
                    this.confirmFlag = true;
                    this.confirmMsg = this.$t(
                      "SERVICECHARGEINFO.SERVICECHARGESUCCESS"
                    );
                    this.orderDetail();
                  }
                }
              })
              .catch(function (error) {
                console.log("修改服务费 请求失败", error);
              });
          }
        })
        .catch(() => {
          this.orderInfo.emergencyServiceFee =
            this.emergencyServiceFee_original;
          this.orderInfo.serviceFees.amount = this.serviceFees_original;
          this.orderInfo.breakfastQty = this.breakfastQty_original
        });
    },
    //清除早餐数
    clearBreakfastQty() {
      this.orderInfo.breakfastQty =
        this.orderInfo.breakfastQty.replace(/^\./g, ""); // 验证第一个字符是数字而不是点
      this.orderInfo.breakfastQty =
        this.orderInfo.breakfastQty.replace(/[^\d]/g, ""); //清除“数字”外的字符      
      this.orderInfo.breakfastQty = this.orderInfo.breakfastQty
        .replace(/^0+\./g, "0.")
        .replace(/^0+([0-9])/, "$1"); //清除.前面无效的0
      if (
        this.orderInfo.breakfastQty.indexOf(".") < 0 &&
        this.orderInfo.breakfastQty != ""
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的
        var qty = parseInt(this.orderInfo.breakfastQty);
        if(qty == NaN){
          this.orderInfo.breakfastQty = 0
        }else{
          this.orderInfo.breakfastQty = qty > 99 ? 99 : qty;
        }
        
      }
    },
    //清除紧急服务费非两位小数的值
    clearNoNumUrgentfee() {
      this.orderInfo.emergencyServiceFee =
        this.orderInfo.emergencyServiceFee.replace(/^\./g, ""); // 验证第一个字符是数字而不是点
      this.orderInfo.emergencyServiceFee =
        this.orderInfo.emergencyServiceFee.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      this.orderInfo.emergencyServiceFee =
        this.orderInfo.emergencyServiceFee.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.orderInfo.emergencyServiceFee = this.orderInfo.emergencyServiceFee
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.orderInfo.emergencyServiceFee =
        this.orderInfo.emergencyServiceFee.replace(
          /^(\-)*(\d+)\.(\d\d).*$/,
          "$1$2.$3"
        ); //只能输入两个小数
      this.orderInfo.emergencyServiceFee = this.orderInfo.emergencyServiceFee
        .replace(/^0+\./g, "0.")
        .replace(/^0+([0-9])/, "$1"); //清除.前面无效的0
      if (
        this.orderInfo.emergencyServiceFee.indexOf(".") < 0 &&
        this.orderInfo.emergencyServiceFee != ""
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.orderInfo.emergencyServiceFee = parseFloat(
          this.orderInfo.emergencyServiceFee
        );
      }
    },
    //清除服务费非两位小数的值
    clearNoNumTotalPrice() {
      this.orderInfo.serviceFees.amount =
        this.orderInfo.serviceFees.amount.replace(/^\./g, ""); // 验证第一个字符是数字而不是点
      this.orderInfo.serviceFees.amount =
        this.orderInfo.serviceFees.amount.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      this.orderInfo.serviceFees.amount =
        this.orderInfo.serviceFees.amount.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.orderInfo.serviceFees.amount = this.orderInfo.serviceFees.amount
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.orderInfo.serviceFees.amount =
        this.orderInfo.serviceFees.amount.replace(
          /^(\-)*(\d+)\.(\d\d).*$/,
          "$1$2.$3"
        ); //只能输入两个小数
      this.orderInfo.serviceFees.amount = this.orderInfo.serviceFees.amount
        .replace(/^0+\./g, "0.")
        .replace(/^0+([0-9])/, "$1"); //清除.前面无效的0
      if (
        this.orderInfo.serviceFees.amount.indexOf(".") < 0 &&
        this.orderInfo.serviceFees.amount != ""
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.orderInfo.serviceFees.amount = parseFloat(
          this.orderInfo.serviceFees.amount
        );
      }
    },
    elongLink() {
      //担保页面传参参数
      let guaranteeParam = {
        hotelName: this.hotelInfo.hotelName,
        checkInAt: formatDateTime(this.orderInfo.checkInDate, "YYYY-MM-DD"),
        checkOutAt: formatDateTime(this.orderInfo.checkOutDate, "YYYY-MM-DD"),
        nights:
          (new Date(this.orderInfo.checkOutDate) -
            new Date(this.orderInfo.checkInDate)) /
          (24 * 60 * 60 * 1000), // 几晚
        breakfastQty: this.orderInfo.breakfastQty, // 早餐数量, 0：不含早， 99：含早，不指定具体份数， 1-99： 指定早餐具体份数
        roomCount: this.orderInfo.roomCount, //房间数
        totalPrice: this.orderInfo.totalPrice, //总价
        floor: this.orderInfo.roomDescriptiveInfo.floor, //房间楼层
        area: this.orderInfo.roomDescriptiveInfo.area, //area
        window: this.orderInfo.roomDescriptiveInfo.hasWindow, //window
        wifi: this.orderInfo.roomDescriptiveInfo.wifi, //wifi
        roomName: this.orderInfo.roomDescriptiveInfo.roomName,
        bookParam: this.orderInfo,
        supportedCreditCards:
          this.orderInfo.paymentInfo.supportedCreditCards == null ||
          this.orderInfo.paymentInfo.supportedCreditCards == undefined
            ? ""
            : this.orderInfo.paymentInfo.supportedCreditCards,
      };
      sessionStorage.setItem(
        "createEGuarantee",
        JSON.stringify(guaranteeParam)
      );
      this.$router.push({
        name: "EGuarantee",
        query: { sourceType: this.$objBaseInfo.sourceType },
      });
    },
    
    showSMSDialog()
    {
      const guestContact = this.orderInfo.guestInfo[0]?.contact || {};
      this.hotelOrderSMS.guestMobile = guestContact.linkerInfo?.mobile || guestContact.mobile || '';
      this.hotelOrderSMS.bookingAgentMobile = this.orderInfo.bookingAgent[0].contact.mobile;
      let smsParam = {
        bookingStatus: this.orderInfo.bookingStatus,
        customerCode: this.orderInfo.customerCode,
        orderNo: this.orderInfo.bookingId,
        name:this.orderInfo.guestNames,
        nameEn:this.orderInfo.guestNamesEn,
        hotelName:this.orderInfo.hotelName, 
        hotelAddress:this.orderInfo.hoteDescriptiveInfo.address,
        hotelTel: this.orderInfo.hoteDescriptiveInfo.contactNumber,
        hotelCityName: "",
        arrivalDate: this.orderInfo.checkInDate,
        departureDate: this.orderInfo.checkOutDate,
        actualCheckInDate: this.orderInfo.checkInDate,
        actualCheckOutDate: this.orderInfo.actualCheckOutDate ? this.orderInfo.actualCheckOutDate : this.orderInfo.checkOutDate,
        inDays: this.orderInfo.nights,
        psrName: this.orderInfo.guestNames,
        roomName:"",
        //roomName: this.orderInfo.roomDescriptiveInfo.name,
        roomNum:"",
        nights:this.orderInfo.nights,
        prepayRule:"",
        totalPrice:this.orderInfo.totalPrice,
        actualTotalPrice:this.orderInfo.totalPrice,
        approvalStatus:this.orderInfo.approvalStatus,
        hotelOrderNo:this.orderInfo.hotelConfirmationNo,
        approvalStatus:this.orderInfo.approvalStatus
      };
      if(Object.prototype.hasOwnProperty.call(this.orderInfo, "cwtadditionalRoomInfo")) {
            let item = JSON.parse(this.orderInfo.cwtadditionalRoomInfo);
            smsParam.roomName = item.RoomTypeName;
      }
      else
      {
          smsParam.roomName = this.orderInfo.roomDescriptiveInfo.name;
      }
      if(this.orderInfo.bookingStatus == "CHECKOUT"){
        //实际总价格
        var actualTotalPrice = 0;
        this.orderInfo.roomStay.forEach(element => {
            var statyDate = Date.parse(formatDateTime(element.stayDate, "YYYY-MM-DD"));
            var actualCheckInDate =  Date.parse(formatDateTime(smsParam.actualCheckInDate, "YYYY-MM-DD"));
            var actualCheckOutDate =  Date.parse(formatDateTime(smsParam.actualCheckOutDate, "YYYY-MM-DD"));
          if(statyDate >= actualCheckInDate && statyDate < actualCheckOutDate){
            actualTotalPrice += element.price;
          }
        });
        smsParam.actualTotalPrice = actualTotalPrice;
      }
      searchSMSModel(smsParam)
      .then((res) => {
        if (res.code == 200) {
          if (res.data.details.length >0) {
            //现在状态为cancel的话 需要判断是否有booked的状态
            let arr=res.data.details;
            if(this.orderInfo.bookingStatus=="CANCELLED")
            {
              let flag=false;
              let booked_Arr=this.orderInfo.specialEvent.filter(o=>o.eventCode.indexOf("booked")>=0 || o.eventCode.indexOf("BOOKED")>=0);
              if(booked_Arr.length>0)
              {
                flag=true;
              }
              //没有booked状态的情况下 只能发送取消短信
              if(!flag)
              {
                arr=arr.filter(p=>p.bookingStatus=="CANCELLED");
              }
            }
            this.hotelOrderSMS.showEnTemplate = this.orderInfo.languageCode == "en" ? "2" : "1",
            this.hotelOrderSMS.hotelOrderSMSInfo = arr;
            this.hotelOrderSMS.choseSMSModel = arr[0].bookingStatus;
            this.hotelOrderSMS.showSMSFlag = true;
            this.changeSelectLanguage();
          }
        }
      })
      .catch(function (error) {
        console.log("修改服务费 请求失败", error);
      });
    },
    changeSelectLanguage(selectTemplate){
      const template = selectTemplate || this.hotelOrderSMS.showEnTemplate;
      this.hotelOrderSMS.smsLanguage = template == "1" ? "CN" : "US";
    },
    clearNoNumBookingAgentMobile(){
      this.hotelOrderSMS.bookingAgentMobile = this.hotelOrderSMS.bookingAgentMobile.replace(/[^\d]/g, "");  //清除“数字”以外的字符
    },
    clearNoNumGuestMobile(){
      this.hotelOrderSMS.guestMobile = this.hotelOrderSMS.guestMobile.replace(/[^\d]/g, "");  //清除“数字”以外的字
    },
    repeatSMS(){
      this.$refs["smsRules"].validate((valid) => {
        if (valid) {
          this.hotelOrderSMS.repeatSMSLoading = true;
          var bookingAgentName;
          for (const element of this.orderInfo.bookingAgent) {
            if(element.type == "2"){
              bookingAgentName = element.name;
            }
          }
          let sendParam = {
            eventCode: this.hotelOrderSMS.choseSMSModel,
            LanguageCode: this.hotelOrderSMS.smsLanguage == "CN"?"zh-CN":"en",
            reservation: {
              bookingId:this.orderInfo.bookingId,
              guestInfo: [{
                type: 0,
                mobile: this.hotelOrderSMS.bookingAgentMobile,
                name: bookingAgentName,
              },
              {
                type: 1,
                mobile: this.hotelOrderSMS.guestMobile,
                name: this.hotelOrderSMS.smsLanguage == "CN"? this.orderInfo.guestNames : this.orderInfo.guestNamesEn,
              }],
              customerCode: this.orderInfo.customerCode,
              hotelName: this.hotelOrderSMS.smsLanguage == "CN"?this.orderInfo.hotelName["zh-CN"]:this.orderInfo.hotelName["en"],
              hoteDescriptiveInfo:{
                address: this.hotelOrderSMS.smsLanguage == "CN"?this.orderInfo.hoteDescriptiveInfo.address["zh-CN"]:this.orderInfo.hoteDescriptiveInfo.address["en"],
                tel: this.orderInfo.hoteDescriptiveInfo.contactNumber,
              },
              roomTypeName:"",
              //roomTypeName: this.hotelOrderSMS.smsLanguage == "CN"?this.orderInfo.roomDescriptiveInfo.name["zh-CN"]:this.orderInfo.roomDescriptiveInfo.name["en"],
              actualCheckOutData: this.orderInfo.actualCheckOutDate?formatDateTime(this.orderInfo.actualCheckOutDate, "YYYY-MM-DD"):"",
              actualCheckInData: this.orderInfo.actualCheckInDate?formatDateTime(this.orderInfo.actualCheckInDate, "YYYY-MM-DD"):"",
              checkInDate: this.orderInfo.checkInDate,
              checkOutDate: this.orderInfo.checkOutDate,
              night: this.orderInfo.nights,
              roomStay: this.orderInfo.roomStay,
              hotelOrderNo: this.orderInfo.hotelConfirmationNo,
            },
          };
          if(Object.prototype.hasOwnProperty.call(this.orderInfo, "cwtadditionalRoomInfo")) {
              let item = JSON.parse(this.orderInfo.cwtadditionalRoomInfo);
              sendParam.reservation.roomTypeName = this.hotelOrderSMS.smsLanguage == "CN"?item.RoomTypeName["zh-CN"]:item.RoomTypeName["en"];
          }
          else
          {
              sendParam.reservation.roomTypeName = this.hotelOrderSMS.smsLanguage == "CN"?this.orderInfo.roomDescriptiveInfo.name["zh-CN"]:this.orderInfo.roomDescriptiveInfo.name["en"];
          }
          sendSMS(sendParam)
          .then((res) => {
            if (res.code == 200) {
              this.confirmFlag = true;
              this.confirmMsg = this.$t("RESENTSMSINFO.RESENTSUCCSEE");
            }else{
              this.confirmFlag = true;
              this.confirmMsg = this.$t("RESENTSMSINFO.RESENTFAIL");
            }
            this.hotelOrderSMS.showSMSFlag = false;
            this.hotelOrderSMS.repeatSMSLoading = false;
          }) 
          .catch(function (error) {
            this.hotelOrderSMS.repeatSMSLoading = false;
          });
        }
        else{
          this.hotelOrderSMS.repeatSMSLoading = false;
        }
      });
    },
    //验证手机号不能为空
    validateMobile(rule, value, callback) {
      if (this.hotelOrderSMS.guestMobile == "" && this.hotelOrderSMS.bookingAgentMobile =="") {
        return callback(new Error(this.$t("RESENTSMSINFO.VALIDATEMOBILE")));
      }
      else {
        return callback();
      }
    },
    //获取菜单列表
    async getMenu() {
      if((this.$objBaseInfo.showOtherProduct_PC && this.$objBaseInfo.channelId == 'WEB')||(this.$objBaseInfo.showOtherProduct_H5&& this.$objBaseInfo.channelId == 'MOBILE')){
        let params = { params: { page: 1, per_page: 1000 } };
        await getUserGetUserMenuList(params)
          .then((res) => {
            if (res.code == 200) {
              if (res.data.error.code != 0) {
                console.log("获取菜单列表请求失败, code:" , res.data.error.code, res.data.error.message);
              } else {
                //this.menuList = res.data.userMenus;
                var menuList = this.$objBaseInfo.channelId == 'WEB' ? res.data.menuList.userMenus : res.data.menuList.h5UserMenus;
                this.getmenuList(menuList)
                this.isOtherProduct = true;
              }
            } else {
              console.log("获取菜单列表请求失败, code:" , res.code, res.message);
            }
          })
          .catch((err) => {
            console.log("获取菜单列表请求失败", err.objError);
          });
      }
    },
    getmenuList(menuList){
      for (const element of menuList) {
        if (!(element.menuCode == "FL01" || element.menuCode == "FL04" || element.menuCode == "FL10" || element.menuCode == "FL08" || element.menuCode == "FL05") || (element.menuCode == "FL05" && !this.orderInfo.isInternational)) {
          this.menuList.push(element);
        }
      }
    },
    async getSSOUrl(menuCode) {
      let jumpParams = {
        params: {
          jumpType: this.$objBaseInfo.jumpType,
          menuFunCode:  this.$objBaseInfo.channelId == 'WEB' ? menuCode : "Menu"+menuCode,
        },
      };
      await jumpLogin(jumpParams)
        .then((res) => {
          this.$parent.menuAllloading = false;
          if (res.code == 200) {
            this.navigateToSafeUrl(res.data);
          } else {
            console.log("OBT菜单转sso跳转失败", res);
          }
        })
        .catch((err) => {
          this.$parent.menuAllloading = false;
          console.log("OBT菜单转sso跳转失败", err.objError);
        });
    },
    navigateToSafeUrl(rawUrl, target = "_self") {
      const safeUrl = sanitizeJumpUrl(rawUrl);
      if (safeUrl) {
        const redirectLink = document.createElement("a");
        redirectLink.href = safeUrl;
        redirectLink.target = target;
        redirectLink.rel = "noopener noreferrer";
        redirectLink.referrerPolicy = "no-referrer";
        redirectLink.click();
      }
    },
     //获取港澳台consul配置
     async getCityConcelValue() {
      let Params = {
        params: {
          key: "CityCodes",
        },
      };
      await getConsul(Params)
        .then((res) => {
          if (res.code == 200) {
            this.CityCodes=res.message.split(',');
          }
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
    
    
    
    bookingsDownLoadPDF(){
      const bookingId = this.$route.query.orderId;
      let params = {
        params: {
          hotelOrderId: bookingId,
        },
      };
      serchHotelOrderEmail(params)
        .then((res) => {
          if(res.code == 200 && res.data){
            const blob = base64ToBlob(res.data, 'application/pdf');
            const downloadLink = document.createElement("a");
            const safeBookingId = String(Array.isArray(bookingId) ? bookingId[0] : bookingId || "").replace(/[^a-zA-Z0-9_-]/g, "");
            const downloadUrl = URL.createObjectURL(blob);
            // .csv 文件后缀
            downloadLink.download = (safeBookingId || "booking") + ".pdf"; // 文件名称
            downloadLink.style.display = "none";
            //csv文件的type  text/csv    xls:application/vnd.ms-excel
            downloadLink.href = downloadUrl;
            downloadLink.click();
            setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
          }else{
            this.confirmFlag = true;
            this.confirmMsg ="下载PDF失败";
          }
        })
        .catch((error) => {
          console.log("下载PDF失败", error);
        });
    },
    ShowRefundDialog(){
      if(this.perPayDetails.isShowFinishOrderBtn){
        this.isShowRefundDialog = true;
      }else{
        var isResent = false;
        if(this.perPayDetails.invoiceStatus == 0){
          isResent = false;
        }else{
          isResent = true;
        }
        this.$router.push({
          name: "Invoicing",
          query: {
            orderId: this.orderInfo.bookingId,
            isResent: isResent
          },
        });
      }
    },
    refundRequest(){
      let params = {
        types: "JD",
        customerId: this.customerCode,
        orderNumber: this.orderInfo.bookingId,
      };
      getrefundlist(params)
        .then((res) => {
          this.isShowRefundRequsetDialog = true;
          if(res.code == 200){
            if(res.data.list.length > 0){
              this.refundRequestInfo.checkinDate = formatDateTime(res.data.list[0].actualCheckInDate,"YYYY-MM-DD");
              this.refundRequestInfo.checkoutDate = formatDateTime(res.data.list[0].actualCheckOutDate,"YYYY-MM-DD");
              this.refundRequestInfo.remark = res.data.list[0].refundReason;
              this.refundRequestInfo.totalAmount = res.data.list[0].refundAmount;
            }else{
              this.refundRequestInfo.checkinDate = this.orderInfo.checkInDate;
              this.refundRequestInfo.checkoutDate = formatDateTime(this.orderInfo.checkOutDate,"YYYY-MM-DD");
            }
          }
        });
    },
    disabledCheckoutDate(time) {
      const checkinDate = this.orderInfo.checkInDate; // 入住日期
      const checkoutDate = this.orderInfo.checkOutDate; // 退房日期
      // 禁用入住日期之前和退房日期之后的日期
      if (checkinDate) {
        const checkinTime = new Date(checkinDate).getTime();
        if (time.getTime() < checkinTime) {
          return true;
        }
      }
      
      if (checkoutDate) {
        const checkoutTime = new Date(checkoutDate).getTime();
        if (time.getTime() > checkoutTime) {
          return true;
        }
      }
      
      return false;
    },
    getRefundAmount(){
      let params = {
        bookingId: this.orderInfo.bookingId,
        isCheckIn: !this.refundRequestInfo.checked,
        checkInDate: this.refundRequestInfo.checkinDate,
        checkOutDate: this.refundRequestInfo.checkoutDate,
      };
      calculateRefundAmount(params)
        .then((res) => {
          if(res.code == 200){
            this.refundRequestInfo.totalAmount = res.data.roundAmount;
          }
        });
    },
    saveRefundInfo(){
      let params = {
        orderNumber: this.orderInfo.bookingId,
        refundAmount: this.refundRequestInfo.totalAmount,
        refundReason: this.refundRequestInfo.remark,
        actualCheckInDate: this.refundRequestInfo.checkinDate,
        actualCheckOutDate: this.refundRequestInfo.checkoutDate,
        isCheckIn: this.refundRequestInfo.checked
      };
      hoteltradeSaveRefund(params)
        .then((res) => {
          
          this.isShowRefundRequsetDialog = false;
          if(res.code == 200){
            if(res.data){
              this.perPayDetails.refundStatus = res.data.applyStatus;
              this.confirmFlag = true;
              this.confirmMsg = this.$t("BANNERINFO.UPDATEADSSUCCESS");
            }else{
              this.confirmFlag = true;
              this.confirmMsg = this.$t("BANNERINFO.UPDATEADSFAIL");
            }
          }
        });
    },
     //验证退款金额不能大于订单总金额
     validateRefundAmount(rule, value, callback) {
      if (value > this.orderInfo.totalPrice) {
        return callback(new Error(this.$t("REFUNDREQUESTINFO.VALIDATEMAXAMOUNT")));
      }
      else {
        return callback();
      }
    },
    async confirmOrder() {
      const options = {
        message: this.$t("REFUNDREQUESTINFO.REFUNDMSG"),
        confirmButtonText: this.$t("INVOICINGBUTTON.CONFIRM"),
        cancelButtonText: this.$t("INVOICINGBUTTON.CANCEL"),
        teleport: "body",
        zIndex: 3000,
      };
      try {
        if (this.$objBaseInfo.channelId == "MOBILE") {
          await showConfirmDialog(options);
        } else {
          await ElMessageBox.confirm(options.message, "", options);
        }
        this.confirmCompletion();
      } catch (action) {
        // 用户取消确认时不执行后续操作。
      }
    },
    confirmCompletion(){
      let params = {
        bookingCode: this.orderInfo.bookingId,
      };
      confirmCompletion(params)
        .then((res) => {
          if(res.code == 200){
            this.isShowRefundDialog = false;
            // this.confirmFlag = true;
            // this.confirmMsg = "订单已确认，如需开具发票，请到订单列表页开具";
            this.orderDetail();
          }
        });
      this.$router.push({
        name: "Invoicing",
        query: {
          orderId: this.orderInfo.bookingId,
          isResent: false
        },
      });
    },
    copyOrderClick(){
      var bookingAgent = this.orderInfo.bookingAgent.find(item => {
        if (item.type == "1" || item.type == "2") {
          return item;
        }
      })
      let params = {
        params: {
          loginId: bookingAgent.userId,
        },
      };
      getuserinfo(params)
      .then((res) => {
        if (res.code === 200) {
          if(res.data.isEnabled && res.data.isActivation && res.data.isUser && res.data.isDel == 0){
            if(this.orderInfo.hoteDescriptiveInfo.group != ''){
              this.getGroupList(this.orderInfo.hoteDescriptiveInfo.group).then(()=>{
                this.rebooking();
              });
            }else{
              this.rebooking();
            }
          }else{
            this.confirmFlag = true;
            this.confirmMsg = this.$t("BOOKING.CopyValidateMsg");
          }
        }
      });
      
    },
    rebooking(){
      var bookingAgent;
      let localGeo = {latitude: "", longitude: ""};
      if (this.orderInfo.hoteDescriptiveInfo.location) {
        localGeo = this.orderInfo.hoteDescriptiveInfo.location.find(item => {
          if (item.geoType == "gps") {
            return item;
          }
        })
      }
      
      if(this.orderInfo.bookingAgent){
        bookingAgent = this.orderInfo.bookingAgent.find(item => {
          if (item.type == "1" || item.type == "2") {
            return item;
          }
        })
        this.$objBaseInfo.loginID = bookingAgent.userId;
      }
      let detailParam = {
        paymentType: '',
        checkInAt: this.orderInfo.checkInDate >= this.getFutureDate(0)?this.orderInfo.checkInDate:this.getFutureDate(1),
        checkOutAt: this.orderInfo.checkInDate >= this.getFutureDate(0)?this.orderInfo.checkOutDate:this.getFutureDate(2),
        roomCount: 1,
        guestCount: 1,
        cwtCityCode: this.orderInfo.cityCode,
        cwtCountryCode:this.orderInfo.hoteDescriptiveInfo.country,
        hotelcode: this.orderInfo.hotelCode,
        isAp: this.orderInfo.isAPHotel,
        isCp: this.orderInfo.isCPHotel,
        latitude: localGeo.latitude.toString(),
        longitude: localGeo.longitude.toString(),
        currencyCode:this.orderInfo.currencyCode,
        sourceType: this.$objBaseInfo.sourceType,
        groupId:this.groupid,
        customerCode:this.orderInfo.customerCode,
        userCode:bookingAgent.userId,
        destinationType:this.orderInfo.isInternational?"I":"D",
        //cwtMark:this.orderInfo.hotelDescriptiveInfo.cwtMarkCode,
      };
      if (this.$objBaseInfo.channelId == "MOBILE") {
        sessionStorage.setItem("mapData", JSON.stringify(detailParam));
        this.$router.push({
          name: "Detail",
          query: detailParam,
        });
      }else{
        if(this.$objBaseInfo.sourceType == 'CRM'){
          // let message = {};
          //   message.customerCode = this.orderInfo.customerCode;
          //   message.customerName = this.orderInfo.customerName;
          //   message.loginID = bookingAgent.userId;
          //   message.loginName = bookingAgent.name;
          //   message.cityCode = this.orderInfo.cityCode;
          //   message.cityName = this.orderInfo.cityName['zh-CN'];
          //   message.checkInAt = detailParam.checkInAt;
          //   message.checkOutAt = detailParam.checkOutAt;
          //   console.log(message);
          //   window.parent.postMessage(message, "*");
          //this.$getInitInfo(this.orderInfo.customerCode,bookingAgent.userId);
          this.$router.push({
              name: "Detail",
              query: detailParam,
            }).then(() => {
              // 跳转成功后刷新页面
              window.location.reload();
            });
        }else {
          var url;
          if (window.location.href.includes('sit')) {
            url = new URL(window.location.origin + '/sit/detail');
          } else {
            url = new URL(window.location.origin + '/detail');
          }
          url.search = new URLSearchParams(detailParam).toString();
          this.navigateToSafeUrl(url.toString(), "_top");
        }
      }
    },
    async getGroupList(groupName) {
      this.submitLoading = true;
      let searchparams = {
        params: {
          groupName: groupName,
          page: 1,
          pageSize: 5,
        },
      };
      await groupList(searchparams)
        .then((res) => {
          if(res.code == 200 && res.data.error.code == 0 && res.data.list.length > 0){
            this.groupid = res.data.list[0].code;
          }
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
    getFutureDate(daysAhead) {
      const date = new Date();
      date.setDate(date.getDate() + daysAhead);
      return  formatDateTime(date,"YYYY-MM-DD");
    },
    // showInvoicing(row){
    //   if (this.hotelOrderShow) {
    //     let message = {};
    //     //url：酒店详情页面地址, orderNo：酒店订单号, userCode：CusomterCode
    //     message.url = location.origin + process.env.BASE_URL + "invoicing";
    //     message.orderNo = row.date;
    //     message.userCode = row.customerCode;
    //     window.parent.postMessage(message, "*");
    //   } else {
    //     this.$router.push({
    //       name: "Invoicing",
    //       query: {
    //         orderId: row.date,
    //       },
    //     });
    //   }
    // }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.formUrl = from.path;
      if (vm.formUrl == "/booking") {
        vm.isbookBreadcrumb = true;
      } else if (vm.formUrl == "/guarantee") {
        vm.isbookBreadcrumb = true;
        vm.isShowGuarantee = true;
      } else {
        vm.isbookBreadcrumb = false;
      }
      // 移除这里的 next() 调用
    });
  },
};
</script>

<style lang="stylus" scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .hotel_container_panel {
    padding: 0;
  }

  .confirmation_panel {
    display: unset;

    .info_detal_l {
      flex: 1;
      overflow: hidden;
      padding-right: 0;
      display: table-row-group;

      .base:not(:last-child) {
        margin-bottom: 1.3rem;
      }
    }

    .info_detal_r {
      display: table-header-group;
      width: unset;
      font-size: 1.2rem;
      font-weight: 400;
    }
  }

  .panel_bg {
    background-color: #FFF;
  }

  .order_confirm_panel {
    background-color: #fff;
    padding: 1.3rem;
    font-size: 1.4rem;

    &.spacing {
      margin-bottom: 1.3rem;
    }

    .span_icon:not(:last-child) {
      height: 100%;
    }

    svg {
      margin-right: 1rem;
      flex: 1;
    }

    .confirm_text {
      font-size: 1.8rem;
      height: 2.8rem;
      line-height: 2.8rem;
      font-weight: 600;
    }
  }

  .icon-title1 {
    color: $approval-color;
  }

  .icon-title2 {
    color: $attention-grabber-color;
  }

  .order_num {
    font-size: 1.4rem;
    height: 2rem;
    line-height: 2rem;
    display: flex;

    .order_title {
      color: $text-fill-color;
      margin-right: 1rem;
    }
  }

  .panel_underline_title {
    border-bottom: 0.2rem solid $btn-bg-color;
    padding-bottom: 1.2rem;
  }

  .order_need_item {
    display: flex;
    margin: 1rem 0;

    .order_need_text {
      // height: 2.4rem;
      line-height: 2.4rem;
      flex: 19;
    }
  }

  .lable_value_review {
    width: 90%;
    height: 2.7rem;
    line-height: 2.7rem;
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1rem;
  }

  .special_req {
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
    margin-top: 1.3rem;

    p {
      line-height: 2.7rem;
    }
  }

  .p_note_matters {
    padding-top: 1.3rem;

    ul {
      list-style-type: demical;

      li {
        list-style-type: demical;
        list-style-position: inside;
      }
    }
  }

  .hotel_info {
    display: flex;
  }

  .div_hotel_info_img {
    width: 70%;
  }

  .hotel_info_img {
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
  }

  .hotel_info_text {
    padding: 1.3rem;
    width: 100%;

    ul {
      display: flex;
      flex-direction: column;
      font-size: 1.4rem;

      li {
        line-height: 2rem;
        padding-bottom: 1.2rem;
        display: inline-block;

        h1 {
          display: inline;
          font-size: 1.8rem;
          /* font-weight: 600; */
          line-height: 2.5rem;
          margin-right: 1.3rem;
        }

        svg {
          padding-right: 1rem;
          vertical-align: middle;
        }

        svg.icon-star {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .panel_dividing_line {
    border-bottom: 0.2rem dashed #e7e9ea;
  }

  .div_guest_order_info {
    padding: 0.9rem 1.3rem;
  }

  .div_room_title {
    line-height: 2.5rem;
    font-size: 1.8rem;
    margin-bottom: 1.3rem;
  }

  .div_room_item {
    display: flex;
    justify-content: space-between;

    .o_title {
      font-size: 1.4rem;
      color: $text-fill-color;
    }

    .o_info {
      font-size: 1.4rem;
    }

    .avg_title, .avg_info {
      font-size: 1.8rem;
      line-height: 2.5rem;
    }

    .total_title, .total_info {
      font-size: 3rem;
      line-height: 4.2rem;
    }
  }

  .room_item_margin:not(:last-child) {
    margin-bottom: 1rem;
  }

  .div_room_button {
    text-align: center;
  }

  .icon-circlecheck {
    vertical-align: -0.4em;
  }

  .price_link {
    text-align: right;
    padding-bottom: 1.3rem;
    font-size: 1.8rem;
    line-height: 2.5rem;
  }

  .dialog_icon {
    width: 4rem;
    height: 4rem;
    margin-right: 1.4rem;
    vertical-align: middle;
  }

  .price-dialog {
    min-width: 20%;
    font-weight: 600;
    ::v-deep .el-dialog {
      width: 90%;

      .el-dialog__title {
        font-size: 1.8rem;
      }

      .el-dialog__headerbtn {
        font-size: 2.5rem;
      }
    }
  }

  ::v-deep .price-dialog .el-dialog__body {
    padding: 1rem 2rem;
  }

  .title-divider {
    margin-bottom: 1rem;
    margin-top: -1rem;
    height: 2px;
    background-color: $btn-bg-color;
  }

  ::v-deep .cancel_dialog {
    .el-dialog__header {
      border-top: 0.2rem solid $btn-bg-color;
      padding-top: 1rem;
    }
  }


  ::v-deep .cancel_dialog {
    .el-dialog__header {
      border-top: 0.2rem solid $btn-bg-color;
      padding-top: 1rem;
    }
  }

  ::v-deep .el-message-box__status {
    color: $btn-bg-color-hover;
  }

  ::v-deep .el-dialog__footer {
    padding-top: 0;
    padding-bottom: 0;
  }

  ::v-deep .el-dialog--center .el-dialog__body {
    padding-top: 1.3rem;
    padding-bottom: 1.3rem;
  }

  ::v-deep .el-table__fixed-right::before, ::v-deep .el-table__fixed::before {
    z-index: inherit;
  }

  ::v-deep .el-form--label-top .el-form-item__label {
    padding: 0px;
  }

  .dialog-footer {
    margin-top: 2rem;
    text-align: center;

    button {
      // padding: 2% 10%;
      border: 1px solid $btn-bg-color;
    }

    .search-btn {
      background-color: $btn-bg-color;
    }
  }

  .updateOrder-dialog ::v-deep .el-dialog__body {
    padding: 2rem 2rem;
  }

  .form-label-field {
    ::v-deep .el-form-item__label {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1.5rem;
      color: $text-fill-color;
    }

    ::v-deep .el-input__inner {
      height: 2.7rem;
      line-height: 2.7rem;
    }
  }
  .van-field{
    line-height: 5rem;
  }
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .add-guest-div {
    display: block;
    float: right;
    margin-right: 6%;
    margin-top: -5rem;
  }

  .add-guest-btn {
    padding: 8px 13px;
    background-color: $btn-bg-color;
    color: $btn-font-color;
    pointer-events: auto;
  }

  .confirmation_panel {
    display: flex;

    .info_detal_l {
      flex: 1;
      overflow: hidden;
      padding-right: 1.3rem;

      .base:not(:last-child) {
        margin-bottom: 1.3rem;
      }
    }

    .info_detal_r {
      width: 37%;
      font-size: 1.2rem;
      font-weight: 400;
    }
  }

  .side_sticky {
    position: sticky;
    top: 0;
  }

  .panel_bg {
    background-color: #FFF;
  }

  .order_confirm_panel {
    background-color: #fff;
    padding: 1.3rem;
    font-size: 1.4rem;

    &.spacing {
      margin-bottom: 1.3rem;
    }

    .span_icon:not(:last-child) {
      height: 100%;
    }

    svg {
      margin-right: 1rem;
      flex: 1;
    }

    .confirm_text {
      font-size: 1.8rem;
      height: 2.8rem;
      line-height: 2.8rem;
      font-weight: 600;
    }
  }

  .icon-title1 {
    color: $approval-color;
  }

  .icon-title2 {
    color: $attention-grabber-color;
  }

  .order_num {
    font-size: 1.4rem;
    line-height: 2rem;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    height: auto;
    max-height: 4rem;
    overflow: hidden;
    white-space: normal;
    word-wrap: break-word;

    .order_title {
      color: $text-fill-color;
      margin-right: 1rem;
    }
  }

  .panel_underline_title {
    border-bottom: 0.2rem solid $btn-bg-color;
    padding-bottom: 1.2rem;
  }

  .order_need_item {
    display: flex;
    margin: 1rem 0;

    .order_need_text {
      // height: 2.4rem;
      line-height: 2.4rem;
      flex: 19;
    }
  }

  .lable_value_review {
    width: 90%;
    height: 2.7rem;
    line-height: 2.7rem;
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
  }

  .special_req {
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
    margin-top: 1.3rem;

    p {
      line-height: 2.7rem;
    }
  }

  .p_note_matters {
    padding-top: 1.3rem;

    ul {
      list-style-type: demical;

      li {
        list-style-type: demical;
        list-style-position: inside;
      }
    }
  }

  .hotel_info {
    display: flex;
  }

  .div_hotel_info_img {
    width: 70%;
  }

  .hotel_info_img {
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
  }

  .hotel_info_text {
    padding: 1.3rem;
    width: 100%;

    ul {
      display: flex;
      flex-direction: column;
      font-size: 1.4rem;

      li {
        line-height: 2rem;
        padding-bottom: 1.2rem;
        display: inline-block;

        h1 {
          display: inline;
          font-size: 1.8rem;
          /* font-weight: 600; */
          line-height: 2.5rem;
          margin-right: 1.3rem;
        }

        svg {
          padding-right: 1rem;
          vertical-align: middle;
        }

        svg.icon-star {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .panel_dividing_line {
    border-bottom: 0.2rem dashed #e7e9ea;
  }

  .div_guest_order_info {
    padding: 0.9rem 1.3rem;
  }

  .div_room_title {
    line-height: 2.5rem;
    font-size: 1.8rem;
    margin-bottom: 1.3rem;
  }

  .div_room_item {
    display: flex;
    justify-content: space-between;

    .o_title {
      font-size: 1.4rem;
      color: $text-fill-color;
    }

    .o_info {
      font-size: 1.4rem;
    }

    .avg_title, .avg_info {
      font-size: 1.8rem;
      line-height: 2.5rem;
    }

    .total_title, .total_info {
      font-size: 3rem;
      line-height: 4.2rem;
    }
  }

  .room_item_margin:not(:last-child) {
    margin-bottom: 1rem;
  }

  .div_room_button {
    text-align: center;
  }

  .icon-circlecheck {
    vertical-align: -0.4em;
  }

  .price_link {
    text-align: right;
    padding-bottom: 1.3rem;
    font-size: 1.8rem;
    line-height: 2.5rem;
  }

  .dialog_icon {
    width: 4rem;
    height: 4rem;
    margin-right: 1.4rem;
    vertical-align: middle;
  }

  .price-dialog {
    min-width: 20%;
    font-weight: 600;
    ::v-deep .el-dialog {
      width: 40%;
    }
  }

  ::v-deep .price-dialog .el-dialog__body {
    padding: 1rem 2rem;
  }

  .title-divider {
    margin-bottom: 1rem;
    margin-top: -1rem;
    height: 2px;
    background-color: $btn-bg-color;
  }

  ::v-deep .cancel_dialog {
    .el-dialog__header {
      border-top: 0.2rem solid $btn-bg-color;
      padding-top: 1rem;
    }
  }

  ::v-deep .cancel_dialog {
    .el-dialog__header {
      border-top: 0.2rem solid $btn-bg-color;
      padding-top: 1rem;
    }
  }

  ::v-deep .el-message-box__status {
    color: $btn-bg-color-hover;
  }

  ::v-deep .el-dialog__footer {
    padding-top: 0;
    padding-bottom: 0;
  }

  ::v-deep .el-dialog--center .el-dialog__body {
    padding-top: 1.3rem;
    padding-bottom: 1.3rem;
  }

  ::v-deep .el-table__fixed-right::before, ::v-deep .el-table__fixed::before {
    z-index: inherit;
  }

  ::v-deep .el-form--label-top .el-form-item__label {
    padding: 0px;
  }

  .dialog-footer {
    margin-top: 2rem;
    text-align: center;

    button {
      // padding: 2% 10%;
      border: 1px solid $btn-bg-color;
    }

    .search-btn {
      background-color: $btn-bg-color;
    }
  }

  .updateOrder-dialog ::v-deep .el-dialog__body {
    padding: 2rem 2rem;
  }

  .form-label-field {
    ::v-deep .el-form-item__label {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1.5rem;
      color: $text-fill-color;
    }

    ::v-deep .el-input__inner {
      height: 2.7rem;
      line-height: 2.7rem;
    }
  }

  .input_pay {
    width: 15%;
  }
}

::v-deep .el-rate__icon {
  font-size: 2rem;
  margin-right: 0;
}

.colorRed {
  color: red;
}

.miNoteFont{
  color:rgb(111, 120, 126);
  font-size:1.4rem;
}
.miNoteFontT{
  cursor:pointer;
  text-decoration:underline;
}
.miNoteFontF{
  cursor:default;
  text-decoration:none;
}
.middle-divider{
  margin-bottom: 1rem;
  margin-top: 2rem;
  height: 2px;
  background-color: $btn-bg-color;
}
.smsModel_div{
  display:flex;
  margin-top: 2rem;
  align-items: center;
}
.smsModelContent_div{
  width: 35rem;
  margin-left: 10rem;
  border: 0.2rem solid #d1c8cc;
  div{
    padding: 2rem;
  }
}
.otherProduct_div{
  text-align: center;
  span{
    font-size: 2rem;
  }
  button{
    margin: 1rem 0;
    background-color: $btn-bg-color;
    color: white;
  }
}
.title-headerDivider {
  margin-bottom: 1rem;
  margin-top: -1rem;
  height: 2px;
  background-color: #fc6640;
}
.refund-roomStay{
  ::v-deep .el-form-item__content {
    line-height: 2.5rem;
  }
}
.refudeHint{
  color:red;
  padding:2rem 0;
}
.footer-button{
  height: 30px;
  margin: 10px;
  padding: 7px;
  background-color: $btn-bg-color;
  color: white;
}
.footer-button-c{
  height: 3rem;
  background-color: $gray-bg-color;
}
::v-deep .el-textarea{
  width:28rem;
}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
  width:181px;
}
</style>
